webpackJsonp([35],{

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(102);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(39)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports
exports.i(__webpack_require__(103), "");
exports.i(__webpack_require__(104), "");
exports.i(__webpack_require__(105), "");
exports.i(__webpack_require__(106), "");
exports.i(__webpack_require__(107), "");
exports.i(__webpack_require__(108), "");

// module
exports.push([module.i, "@tailwind base;@tailwind components;@tailwind utilities;.fontMini,.module.errorModal .detailError{font-size:16px;font-size:1.6rem}.btn,.fontBody,.module.errorModal .detailError.detail,.module.inputForm .boxViewValue p,.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject,.module.layoutWithSidebar .menuSidebar,.module.layoutWithSidebar .sidebarBox .actionBox .userBox p,.module.layoutWithSidebar .sidebarBox .headerBox .text p,.module.popupUser .userContent .contentDetail .detailUser .email,.ui.button,p{font-size:18px;font-size:1.8rem;line-height:25px}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.form,.ui.input{font-size:18px!important;font-size:1.8rem!important}.fontHeader,.module.customTable .boxNoData p,.module.errorModal .detailError.header,.module.header .menu-item.text,.module.header .menuMobile,.module.inputForm .headerBoxHeaderTap,.module.popupUser .userContent .contentDetail .detailUser .name{font-size:20px!important;font-size:2rem!important}.boxHeaderPage p,.fontHeaderBody,.fontHeaderPage{font-size:32px;font-size:3.2rem}.fontSettingValueView{font-size:24px;font-size:2.4rem}.fontStep,.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{font-size:16px!important;font-size:1.6rem!important}.btn{font-weight:700!important;min-width:100px}.btnPicker>.ui.basic.button,.btnPicker>.ui.basic.button:active,.btnPicker>.ui.basic.button:hover{background-color:inherit!important;border:none;box-shadow:none!important}.ui.button.btnLogin{background-color:#000;color:#e0e0e0;margin:0;width:9rem;height:9rem;font-size:35px;margin-top:7rem;cursor:pointer}.ui.button.btnAdd{padding:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.ui.button.btnAdd .i.icon,.ui.button.btnAdd i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnAddMinus{padding:0;width:30px;height:30px;color:#0f1a28;background-color:transparent;font-size:13px}.ui.button.btnAddMinus .i.icon,.ui.button.btnAddMinus i.icons{padding-right:2px!important}.ui.button.btnAddMinus.disable{color:#ababab}.btnAddBlueText,.ui.button.btnAddBlueText{padding:0 15px;margin:0;height:40px;border-radius:20px;color:#e0e0e0;background-color:#1e48f9;font-size:16px;min-width:100px;margin-left:5px}.btnAddText,.ui.button.btnAddText{padding:0 15px;height:30px;color:#e0e0e0;background-color:#1b2c57;margin-left:5px!important}.btnAddText.transfer,.btnAddTextInvert.transfer{background-color:#0f1a28;min-width:100px;height:50px!important;width:100%}.btnAddTextInvert,.ui.button.btnAddTextInvert{padding:0 15px;margin:0;height:30px;color:#1b2c57;background-color:#e0e0e0;font-size:13px;min-width:100px;margin-left:5px}.btnAddTextInvert.marginLeft5,.ui.button.btnAddTextInvert.marginLeft5{margin-left:5px!important}.btnAddTextInvert.reportSize,.ui.button.btnAddTextInvert.reportSize{height:100px;min-width:300px;font-size:20px}.btnAddTextInvert.reportSize:focus,.ui.button.btnAddTextInvert.reportSize:focus{-webkit-box-shadow:0 0 6px 5px rgba(255,0,0,.9);box-shadow:0 0 6px 5px rgba(255,0,0,.9)}.btnEditBlueText,.ui.button.btnEditBlueText{padding:0 15px;margin:0;height:30px;color:#e3e4e3;background-color:#1e48f9;font-size:13px;min-width:100px;margin-left:5px}.btnSubmitItemText,.ui.button.btnSubmitItemText{background-color:#f19fff}.btnCancelText,.btnSubmitItemText,.ui.button.btnCancelText,.ui.button.btnSubmitItemText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;min-width:100px;margin-left:5px}.btnCancelText,.ui.button.btnCancelText{background-color:#d83838}.btnCancelText.marginLeft5,.ui.button.btnCancelText.marginLeft5{margin-left:5px!important}.btnCancelText.reportSize,.ui.button.btnCancelText.reportSize{height:100px;min-width:300px;font-size:20px}.btnCancelEditText,.ui.button.btnCancelEditText{padding:0 15px;margin:0;height:30px;color:#353386;background-color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnCancelTextInvert,.ui.button.btnCancelTextInvert{color:#d83838;border:1px solid #d83838}.btnCancelTextInvert,.btnUpdate,.ui.button.btnCancelTextInvert,.ui.button.btnUpdate{padding:0 15px;margin:0;height:30px;background-color:#e3e4e3;font-size:13px;margin-left:5px;min-width:100px}.btnUpdate,.ui.button.btnUpdate{color:#383838;border:1px solid #e0e0e0}.btnAddItemText,.ui.button.btnAddItemText{background-color:#1e48f9}.btnAddItemText,.btnValidateText,.ui.button.btnAddItemText,.ui.button.btnValidateText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnValidateText,.ui.button.btnValidateText{background-color:#353386}.btnGencodeText,.ui.button.btnGencodeText{background-color:#119303}.btnEditText,.btnGencodeText,.ui.button.btnEditText,.ui.button.btnGencodeText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnEditText,.ui.button.btnEditText{background-color:#9646ff}.btnEditText.reportSize,.ui.button.btnEditText.reportSize{height:100px;min-width:300px;font-size:20px}.btnEditText.reportSize:focus,.ui.button.btnEditText.reportSize:focus{-webkit-box-shadow:0 0 6px 5px rgba(255,0,0,.9);box-shadow:0 0 6px 5px rgba(255,0,0,.9)}.btnEditYellowText,.ui.button.btnEditYellowText{padding:0 15px;margin:0;height:30px;color:#353386;background-color:#dde01a;font-size:13px;margin-left:5px;min-width:100px}.btnApproveText,.ui.button.btnApproveText{background-color:#119303}.btnApproveText,.btnBackText,.ui.button.btnApproveText,.ui.button.btnBackText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnBackText,.ui.button.btnBackText{background-color:#f7213b}.ui.button.btnView{padding:0;margin:0;width:30px;height:30px;color:#353386;font-size:13px}.ui.button.btnView .i.icon,.ui.button.btnView i.icons{padding-right:2px!important;color:#353386}.ui.button.btnView.marginLeft{margin-left:5px}.ui.button.btnView.marginRight{margin-right:5px}.ui.button.btnSearch{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.ui.button.btnSearch .i.icon,.ui.button.btnSearch i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnSearchInvert{padding:0;margin:0;width:40px;height:40px;color:#1b2c57;background-color:#e0e0e0;font-size:13px}.ui.button.btnSearchInvert .i.icon,.ui.button.btnSearchInvert i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnReloadData{padding:0;margin:0;width:40px;height:40px;color:#1b2c5721;background-color:#e0e0e03d;font-size:13px}.ui.button.btnReloadData .i.icon,.ui.button.btnReloadData i.icons{padding-right:2px!important;color:#e0e0e0}.btnUploadFile,.ui.button.btnUploadFile{padding:0 15px;margin:0;height:49px;background-color:#fff;font-size:13px;margin-left:5px;min-width:100px;border:1px solid;border-color:#dededf}.ui.button.btnDeleteFile{padding:0;margin:0;width:20px;height:20px;color:#e70000;background:hsla(0,0%,100%,0);font-size:13px}.ui.button.btnDeleteFile .i.icon,.ui.button.btnDeleteFile i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnDownloadFile{padding:0;margin:0;width:20px;height:20px;color:#1b2c57;background:hsla(0,0%,100%,0);font-size:18px}.ui.button.btnDownloadFile .i.icon,.ui.button.btnDownloadFile i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.addNewItem{font-size:3rem;height:1vh;background:url(/assets/images/btn_add.png);background-repeat:no-repeat;background-size:contain;padding-left:1vh}.ui.button.btnEdit{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#dde01a;font-size:13px;margin-left:5px}.ui.button.btnEdit .i.icon,.ui.button.btnEdit i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnDelete{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#d83838;font-size:13px;margin-left:5px}.ui.button.btnDelete .i.icon,.ui.button.btnDelete i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnConfirm{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#06be2e;font-size:13px;margin-left:5px}.ui.button.btnConfirm .i.icon,.ui.button.btnConfirm i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnActionModal{padding:0;margin:0;width:30px;height:30px;color:#000;background-color:unset;font-size:13px;margin-left:5px}.ui.button.btnActionModal .i.icon,.ui.button.btnActionModal i.icons{padding-right:2px!important;color:#e0e0e0}.iconBtnConfirm{padding:0;margin:0!important;width:30px!important;height:30px!important;color:#e0e0e0;background-color:#0b6ddd;font-size:13px!important;border-radius:3px;padding-top:7.5px}.btnIcon,.ui.circular.btnIcon{width:40px;height:40px;margin-top:20px;padding:0!important;padding-right:2px!important}.btnIcon .ui.circular.button>.icon,.ui.circular.btnIcon .ui.circular.button>.icon{padding-right:2px!important;margin-top:5px!important}.btnIcon i.icon:hover,.ui.circular.btnIcon i.icon:hover{background-color:inherit!important;color:inherit!important;border:inherit!important}.ui.circular.btnIcon>.icon{font-size:20px;padding-top:5px;padding-right:2px!important}.ui.button.btnDisplay{height:23vh;width:23vh;background-repeat:no-repeat;background-size:cover}.ui.button.btnDisplay.login{background:url(\"/assets/images/icon_card.png\");background-size:100%;background-repeat:no-repeat}.ui.button.btnDisplay.loginFail{background:url(\"/assets/images/icon_card_fail.png\");background-size:100%;background-repeat:no-repeat}.ui.button.btnDisplay.loginAdmin{background:url(\"/assets/images/button/btn_card_admin.png\");background-size:100%;background-repeat:no-repeat}.ui.button.btnDisplay.btnStart{background:url(\"/assets/images/button/btn_start.png\");background-size:100%}.ui.button.btnDisplay.btnStart.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnStart.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnResume{background:url(\"/assets/images/button/btn_resume.png\");background-size:100%}.ui.button.btnDisplay.btnResume.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnResume.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnLogout{background:url(\"/assets/images/button/btn_logout.png\");background-size:100%}.ui.button.btnDisplay.btnLogout.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnLogout.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnStop{background:url(\"/assets/images/button/btn_stop.png\");background-size:100%}.ui.button.btnDisplay.btnStop.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnStop.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnPause{background:url(\"/assets/images/button/btn_pause.png\");background-size:100%}.ui.button.btnDisplay.btnPause.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnPause.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnFinish{background:url(\"/assets/images/button/btn_finish.png\");background-size:100%}.ui.button.btnDisplay.btnFinish.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnFinish.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnCheckInOut{background:url(\"/assets/images/button/btn_checkInOut.png\");background-size:100%}.ui.button.btnDisplay.btnCheckInOut.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnCheckInOut.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnHelp{background:url(\"/assets/images/button/btn_help.png\");background-size:100%}.ui.button.btnDisplay.btnHelp.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnHelp.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnEnter{background:url(\"/assets/images/button/btn_confirm.png\");background-size:100%}.ui.button.btnDisplay.btnEnter.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnEnter.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnBackDisplay{background:url(\"/assets/images/button/btn_back.png\");background-size:100%}.ui.button.btnDisplay.btnBackDisplay.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnBackDisplay.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnArrowUp{background:url(\"/assets/images/button/btn_arrow_up.png\");background-size:100%}.ui.button.btnDisplay.btnArrowUp.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnArrowUp.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnArrowDown{background:url(\"/assets/images/button/btn_arrow_down.png\");background-size:100%}.ui.button.btnDisplay.btnArrowDown.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnArrowDown.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnSettings{background:url(\"/assets/images/button/btn_settings.png\");background-size:100%}.ui.button.btnDisplay.btnSettings.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnSettings.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnDeleteData{background:url(\"/assets/images/button/btn_delete.png\");background-size:100%}.ui.button.btnDisplay.btnDeleteData.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnDeleteData.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnMenuSelect{width:77vw;margin-bottom:1.5vh;font-size:3.7em;height:12.5vh;background-color:#fff}.ui.button.btnDisplay.btnMenuSelect:focus{border-radius:unset!important;color:#353386!important;background-color:#ff0048}.btnAddText,.ui.button.btnAddText{padding:0 30px;margin:0;height:40px;color:#272727;background-color:#f2711c;font-size:13px;min-width:100px;margin-left:5px}.btnAddUpdate,.btnAddView,.ui.button.btnAddUpdate,.ui.button.btnAddView{padding:9px;height:41px;color:#272727;background-color:#f2711c;font-size:18px;min-width:75px;margin:auto}.baseBtn{display:flex;justify-content:flex-end}.baseBtn button{padding:4px!important;font-size:12px!important}.baseBtn button,.baseBtn button:hover{color:#fff!important}.baseBtn .segment{margin-bottom:0;background:transparent;border-radius:4px;border:2px solid #fff;margin-right:10px}.baseBtn .segment .ui.toggle.checkbox input:checked~label:before{background-color:#067692!important}.baseBtn .segment label{font-size:12px!important}.ui.checkbox,.ui.dropdown,.ui.form,.ui.form .field>label,.ui.form textarea,.ui.input,.ui.input input,.ui.steps .step .title,.ui[class*=\"left icon\"].input>input,a,body,button,div,h1,h2,h3,h4,h5,h6,p,span{font-family:IBM!important}body{background-color:#f9f9f9}p{margin:0;color:#3c4047}.ui.checkbox,.ui.checkbox label,.ui.dropdown,.ui.form,.ui.form textarea,.ui.input,.ui.input input{color:#3c4047!important}@keyframes crescendo{0%{transform:scale(.8)}to{transform:scale(1.5)}}.gridNogMargin,.gridNoPaddingMargin,.gridNoPaddingMargin>.column,.gridNoPaddingMargin>.row,.gridNoPaddingMargin>.row>.column{padding:0!important;margin:0!important}.gridColumnNoPaddingTB{padding-top:0!important;padding-bottom:0!important}.contentHeightMax{height:100%}.scrollListFormBox{height:140px;overflow-y:scroll;padding:1rem;background-color:#353386}.boxDatePicker{width:200px}.boxDatePicker.fluid{width:100%}.listSelectAll{padding-bottom:.42857143em;padding-top:.42857143em;background-color:#fff}.iWAAXb{padding:0 25px 0 10px!important}.ui.dimmer{z-index:2000!important;position:fixed!important}.iconMenuRowTable{cursor:pointer}.boxHeaderPage p{font-weight:700}.noselect{-webkit-touch-callout:none!important;-webkit-user-select:none!important;-khtml-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}@media only screen and (max-width:767px){.customContainer,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:10px;padding-right:10px}.customContainer .boxHeader.desktop,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop{display:none}.customContainer .boxBody .boxContent,.module.layoutMaster .boxBody .boxContent .contentBox .boxBody .boxContent{padding-top:50px}.customContainer .module.transfer .desktop,.module.layoutMaster .boxBody .boxContent .contentBox .module.transfer .desktop{display:none}}@media only screen and (min-width:768px) and (max-width:991px){.customContainer,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:30px;padding-right:30px}.customContainer .boxHeader.desktop,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop,.module.layoutMaster .boxBody .boxContent .contentBox .module.transfer .mobileSize{display:none}}@media only screen and (min-width:992px) and (max-width:1199px){.customContainer,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:60px;padding-right:30px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxBody .boxContent .contentBox .module.transfer .mobileSize{display:none}}@media only screen and (min-width:1200px) and (max-width:1919px){.customContainer,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:100px;padding-right:60px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxBody .boxContent .contentBox .module.transfer .mobileSize{display:none}}@media only screen and (min-width:1920px){.customContainer,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:150px;padding-right:60px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxBody .boxContent .contentBox .module.transfer .mobileSize{display:none}}.scrollListFormBox{height:200px;overflow-y:auto;overflow-x:hidden;border:1px solid #e6e7e8;border-radius:.285714rem;background-color:#fff;padding:10px}.cursor-pointer{cursor:pointer}.div-flex{display:flex}p.white-space{white-space:normal}p.textDetailModal,p.white-space{color:rgba(0,0,0,.87);font-size:16px}b.textSubjectModal{font-size:16px;color:#2c75b7}.tooltip{position:relative;display:inline-block}.tooltip .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;padding:5px 0;border-radius:6px;position:absolute;z-index:1}.tooltip:hover .tooltiptext{visibility:visible}.MuiTypography-body1{font-size:1.5rem!important}.MuiTypography-body2{font-size:1.25rem!important}.MuiTypography-caption{font-size:1.2rem!important}.MuiTypography-subtitle1{font-size:2rem!important}.MuiButton-root{font-size:1.25rem!important}.MuiPickersModal-dialogRoot{width:370px!important}.MuiPickersBasePicker-pickerView{min-width:370px!important;width:370px}.flagMenu.active{width:30px;opacity:1;cursor:pointer}.flagMenu{opacity:.5;width:30px;cursor:pointer}.paddingLeft5{padding-left:5px}.padding10{padding:10px}.padding15{padding:15px}.padding20{padding:20px}.marginLeft5{margin-left:5px}.marginLeft10{margin-left:10px}.margin10{margin:10px}.ui.steps{border:none}.kQuRQn{overflow-x:unset!important;overflow-y:unset!important}.iBMnVw{cursor:pointer}.eRFaRs{overflow-y:unset!important}.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{border-radius:5px;min-width:100px;height:50px;background-color:#e0e0e0;color:#3c4047}.ui.steps .step:after{display:none!important}.ui.steps .step.active,.ui.steps .step.active:hover{background-color:#353386!important}.ui.steps .step.active .title,.ui.steps .step.active .title:hover{color:#e0e0e0!important}.ui.steps a.step:hover{background-color:#e0e0e0!important}.ui.form .disabled.field,.ui.form .disabled.fields .field,.ui.form .field.disabled>label,.ui.form .field :disabled,.ui.form .fields.disabled>label{opacity:1;cursor:not-allowed}.ui.form .field>label{min-height:20px}.textOverflow{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:disabled{background:#f1f2f2;outline:none;border:none}.ui.menu{background-color:#f9f9f9}.ui.form .field>.selection.dropdown{min-width:100%}.ui.selection.active.dropdown .menu{width:150px}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.dropdown>.text,.ui.form,.ui.input{font-size:16px!important;color:#000;font-weight:500}.ui.input.error>input{background-color:#fff6f6;border-color:#e0b4b4;color:#9f3a38;-webkit-box-shadow:none;box-shadow:none}.ui.form .field .ui.input input,.ui.form .fields .field .ui.input input{padding:5px!important;font-weight:200}.MuiTableSortLabel-root{font-size:16px;padding:5px 0!important;font-weight:800}.MuiTableRow-head,.MuiTableRow-hover,.MuiTableRow-root{padding:15px}.MuiTableCell-paddingNone{padding:inherit!important}.MuiTableCell-root,.MuiTablePagination-select{font-size:16px!important;font-weight:300!important}.footer{position:fixed;bottom:0;right:0;padding:20px 10px;text-align:right;background-color:#f9f9f9;width:100vw}.footer.center{text-align:center}.footer.mobile{padding:10px}.ui.form .field .ui.input,.ui.form .fields .field .ui.input,.ui.form .wide.field .ui.input{height:40px}.ui.steps .step .title{font-size:16px}.ui.disabled.input,.ui.input:not(.disabled) input[disabled]{opacity:.7}.ui.disabled.dropdown,.ui.disabled.dropdown .ui.dropdown>.text,.ui.disabled.input>input,.ui.disabled.input>input .ui.dropdown>.text,.ui.input:not(.disabled) input[disabled],.ui.input:not(.disabled) input[disabled] .ui.dropdown>.text{background-color:#dadada;color:#5a5a5a!important}.ui.form .inline.fields{margin:0}.ui.table{border:none}.ui.table thead{width:100%}.ui.sortable.table thead th{font-size:19px;text-align:center;font-weight:700;background-color:#e4e4e4}.ui.celled.table tr td,.ui.celled.table tr th{font-size:17px;overflow-wrap:anywhere}.ui.sortable.table thead th.noSort:hover{background:#f7f7f7;color:inherit;cursor:inherit}.cursorPointer{cursor:pointer}.marginBottom10{margin-bottom:10px!important}.width100{width:100%!important}.homePage{width:100%;display:flex!important;justify-content:center;align-items:center!important;margin-top:35vh!important;text-align:center}.pageNotFound img.ui.image{display:inline-flex;width:250px}.pageNotFound h1{font-size:26px}.pageNotFound .char404{font-size:36px;color:#ff2d2d}@media{.page-break{display:none}}@media print{body,html{-webkit-print-color-adjust:exact}}@media print{.page-break{page-break-before:always}}.menu-height{height:100%;max-height:calc(100vh - 200px)}.annoubementAlertNew{animation-name:newAnnounce;animation-duration:2s;animation-iteration-count:infinite;animation-direction:alternate;background:red;color:#fff}@keyframes newAnnounce{0%{background:red}25%{background:#ff0}75%{background:red}to{background:#ff0}}.component-class{height:calc(100vh - 100px);overflow-y:auto}.content-coming-page h2{color:#fff;font-size:4em;position:absolute;transform:translate(-50%,-50%)}.content-coming-page h2:first-child{color:transparent;text-transform:uppercase;font-weight:700;-webkit-text-stroke:2px #475569}.content-coming-page h2:nth-child(2){color:#475569;text-transform:uppercase;font-weight:700;animation:animateComingPage 4s ease-in-out infinite}@keyframes animateComingPage{0%,to{clip-path:polygon(0 45%,16% 44%,33% 50%,54% 60%,70% 61%,84% 59%,100% 52%,100% 100%,0 100%)}50%{clip-path:polygon(0 60%,15% 65%,34% 66%,51% 62%,67% 50%,84% 45%,100% 46%,100% 100%,0 100%)}}.detail-coming h3{color:#475569;font-weight:700;font-size:2em;text-decoration:none;text-transform:uppercase;letter-spacing:6px;display:inline-block;position:relative;-webkit-mask-image:linear-gradient(-75deg,hsla(0,3%,85%,.6) 30%,#000 50%,hsla(0,3%,85%,.6) 70%);-webkit-mask-size:200%;animation:shine 3s linear infinite}.lineStepFlow{height:100%;position:absolute;overflow:hidden;width:4px}.lineStepFlow:after,.lineStepFlow:before{position:absolute;top:0;left:0;right:0;bottom:0;content:\"\"}.lineStepFlow:before{content:\"\";display:block;width:5px;height:300px;background:#22c55e;position:absolute;top:-100%;left:0;animation:animate 5s ease-in-out infinite}@keyframes animate{0%{top:-100%}50%{top:0}to{top:100%}}.MuiDialog-root{z-index:9999!important}.container-logo-wrap:hover .message-box-logo{animation-name:bounceLogo;-moz-animation-name:bounceLogo;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite}.message-box-logo:before{content:\"\";position:absolute;bottom:-4px;border-top:7px solid #4879ed;left:0;border-right:8px solid transparent}@keyframes bounceLogo{0%,20%,50%,80%,to{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0) scaleY(1)}40%{-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px) scaleY(.7);box-shadow:3px 4px 7px -1px #4879ed}60%{-webkit-transform:translateY(-5px);-ms-transform:translateY(-5px);transform:translateY(-5px) scaleY(.9);box-shadow:3px 4px 7px -1px #4879ed}}.react-datepicker{font-size:1.1em}.react-datepicker__header{padding-top:.8em}.react-datepicker__month{margin:.4em 1em}.react-datepicker__day,.react-datepicker__day-name{width:1.9em;line-height:1.9em;margin:6px!important;font-size:12px!important}.react-datepicker__current-month{font-size:14px!important}.react-datepicker__navigation{top:1em;line-height:1.7em;border:.45em solid transparent}.react-datepicker__navigation--previous{border-right-color:#ccc;left:1em}.react-datepicker__navigation--next{border-left-color:#ccc;right:1em}.react-datepicker-time__caption{font-size:12px!important}.react-datepicker__input-time-container{display:flex!important;align-items:center!important}.react-datepicker__input-time-container .react-datepicker-time__input{font-size:12px!important}.headerForm{margin-bottom:10px!important}.titleField.bold{font-weight:700;font-size:14px!important;color:rgba(0,0,0,.87)}.ui.checkbox+label,.ui.checkbox label,.ui.form .field>label{color:#3c4047!important;font-size:16px!important}input{position:relative}input[type=date]::-webkit-calendar-picker-indicator{background-position:100%;background-size:auto;cursor:pointer;position:absolute;bottom:0;left:0;right:2px;top:0;width:auto;margin:auto 0}.text-center{text-align:center}.text-center.charLimit{margin-top:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:80px;font-size:9pt}.collectData{color:green;font-size:10pt}.rightButton{text-align:right!important}.totalUserField{font-size:14px}.userManageForm{border-radius:5px;border:1px solid #000;padding:10px}.userManageForm .headerSection{border-radius:5px;border-bottom:1px solid #000}.userManageForm .bodySection{max-height:200px;overflow-y:auto}.userManageForm .header{font-size:12px;font-weight:700}.userManageForm .text{font-size:8px;font-weight:400}.ui.modal .close.icon{margin-right:35px;margin-top:30px;color:#000;font-size:2em}input[type=file]{border-radius:0!important}.opacityGrayBg{background:#bababa29}.emailInputLogin{border-top-right-radius:0!important;border-bottom-right-radius:0!important}.allMenuFlex{width:100%;flex-wrap:wrap}.allMenuFlex .iconMenu{padding:5px}.popup .content{font-size:12px!important}.jUzDqZ{background:#afafaf29!important}.rdt_TableRow:hover{background:#cacaca29!important}.tab-size .menu .item{font-size:10px!important}.tab-sizeTwo .menu .item{font-size:12px!important}@media screen and (max-width:768px) and (max-width:767px){.charLimit{font-size:10px!important;max-width:40px!important}.iconMenu{width:40px!important;display:flex;justify-content:center;flex-direction:column;align-items:center}.rdt_TableCell,.rdt_TableCol{min-width:200px!important}.tab-size .menu .item{font-size:50px!important}}@media screen and (min-width:768px){.component-class{max-width:1920px!important;margin:0 auto}}.tab-wrapper .menu .item:hover{background-color:#000!important;color:#ccc!important;size:5px}.tab-wrappers .menu{width:100%!important}.tab-wrappers .menu .item{font-size:12px!important}.tab-wrappers .menu .item:hover{background-color:#000!important;color:#ccc!important;size:5px}.tab-wrapperlg .menu .item{font-size:25px!important;size:5px!important}.tab-wrapperlg .menu .item:hover{background-color:#000!important;color:#ccc!important;size:5px}.apexcharts-datalabel-value .menu .item{font-size:5px!important}@media screen and (min-width:768px){.tab-wrappers .menu{width:100%!important}.tab-wrappers .menu .item{font-size:12px!important}.tab-wrappers .menu .item:hover{background-color:#000!important;color:#ccc!important;size:5px}}.main-card{background:#fafafa;border-radius:8px!important;padding:24px!important;margin-bottom:12px;box-shadow:10px 10px 30px #bebebe,-10px -10px 30px #fff}.detail-card{background:#e5e7eb;border-radius:8px;padding:6px;box-shadow:0 1px 3px #0000001a,0 1px 2px -1px #0000001a}.module.loadableController,.module.loadableRoute{height:100vh;display:flex;justify-content:center;align-items:center}.module.loadableController{position:fixed;overflow:auto}.module.switchLanguage{display:flex}.module.switchLanguage .language-item.select{background-color:#ccc}.module.errorBoundary .grid-header{padding-top:50px}.module.header{margin:0;box-shadow:0 4px 12px 0 rgba(0,0,0,.05)!important;background-color:#353386!important;position:absolute;width:100%;margin:0!important;top:0;z-index:2000}.module.header .logo-box{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.module.header .logo-box img{display:inline-block;max-width:100%;max-height:100%}.module.header .menu-item.logoUser{padding-top:0;padding-bottom:0}.module.header .menu-item.logo{padding:0;width:150px;height:50px}.module.header .menu-item.text p{color:#353386!important;font-weight:700}.module.header .menuBoxDesktop{width:100%}.module.header .menuBoxDesktop .menuRight{width:100%;height:100%;justify-content:flex-end}.module.header .menuBoxMobile{width:100%;display:flex}.module.header .menuMobile{padding:0!important}.module.header .menuMobile>i{display:none!important}.module.header .imageMenuMobile>i{margin:0!important}.module.header .itemMenuDropdown,.module.header .subMenuDropdown{width:180px}.module.header .userImage{width:40px;height:40px;border-radius:50%;overflow:hidden;cursor:pointer}.module.header .userImage img{width:100%;height:100%}.module.errorModal>.header{background-color:#353386}.module.errorModal>.actions,.module.errorModal>.header{border:none!important;padding:15px!important}.module.errorModal .boxHeaderContent{height:100px;display:flex;justify-content:center;align-items:center}.module.errorModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:15px;opacity:.3;cursor:pointer}.module.errorModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.errorModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.errorModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.errorModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.errorModal .itemError{padding:10px 0!important}.module.errorModal .detailError{margin:0}.module.errorModal .detailError.header{font-weight:700}.module.errorModal .boxErrorParam{padding-left:15px}.module.actionModal .ui.button{font-size:16px;padding:10px;margin:0!important;background-color:#1b2c57;color:#ccc}.module.actionModal .danger p,.module.actionModal .warning p{color:#353386}.module.actionModal .danger .dialogHeader{padding-top:5px}.module.actionModal .danger .boxImageClose{margin-top:15px}.module.actionModal .headerBG{height:65px}.module.actionModal .headerBG.danger,.module.actionModal .headerBG.detail,.module.actionModal .headerBG.warning{background-color:#e6e7e8}.module.actionModal>.actions,.module.actionModal>.header{border:none!important;padding:15px!important}.module.actionModal .boxHeaderContent{display:flex;justify-content:center;align-items:center;flex-direction:column}.module.actionModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:-5px;opacity:.3;cursor:pointer}.module.actionModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.actionModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.actionModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxTextHeader p{font-size:16px;font-weight:700}.module.actionModal .boxTextDetail{min-height:9vh;max-height:60vh;overflow-y:scroll;overflow-x:hidden}.module.actionModal .boxAction{margin-top:1.5rem;position:absolute;z-index:999;text-align:center;width:100%;margin-bottom:5px}.module.inputForm{width:100%}.module.inputForm .formField{margin:0!important}.module.inputForm .formField.pickerType{position:relative}.module.inputForm .disabledInput{opacity:.45}.module.inputForm .boxViewValue{background-color:#fff;padding:1rem}.module.inputForm .boxViewValue p{margin:0!important}.module.inputForm .boxViewValue.mini{width:20%}.module.inputForm .boxViewValue.small{width:50%}.module.inputForm .labelInput p{margin:0!important}.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject{font-weight:700;display:inline-block}.module.inputForm .labelInput .required{color:red}.module.inputForm .boxDatePicker>.MuiFormControl-root{display:none!important}.module.inputForm .textValid{color:red}.module.inputForm .hidePicker{display:none}.module.inputForm .inputFile,.module.inputForm .inputFile input,.module.inputForm .inputPicker,.module.inputForm .inputPicker input{opacity:unset!important}.module.inputForm .btnPicker,.module.inputForm .btnUploadFile{position:absolute;top:50%;right:0;transform:translateY(-50%)}.module.inputForm .btnPicker button,.module.inputForm .btnUploadFile button{transform:translateX(-30%)}.module.inputForm .boxColumSubjectTop{padding-top:1rem!important}.module.inputForm .headerBoxHeaderTap{font-weight:700}.module.inputForm .editorInputHtml{height:275px!important;border:1px solid #f1f1f1!important;padding:5px!important;border-radius:2px!important;background-color:#fff}.module.inputForm .boxInputUploadFile{display:flex}.module.inputForm .boxInputUploadFile .inputBox{flex:1}.module.inputForm .boxInputUploadFile .actionBox{flex:0 0 auto}.module.inputForm .boxInputUploadFile .actionBox button{height:100%;margin-right:0;margin-left:.5rem}.module.popupUser .userContent{display:flex;widows:200px}.module.popupUser .userContent .contentImage{flex:0 0 auto;width:70px;height:70px;border-radius:50%;overflow:hidden}.module.popupUser .userContent .contentImage img{width:100%;height:100%}.module.popupUser .userContent .contentDetail{padding-left:1rem;flex:1}.module.popupUser .userContent .contentDetail .detailUser .name{font-weight:700}.module.popupUser .userAction{border-top:1px solid #ccc;display:flex;justify-content:flex-end;margin-top:1rem;padding-top:1rem}.module.popupUser .userAction button{padding-top:.5rem;padding-bottom:.5rem}.holiday{background:#f1f1f1}.speciaoHliday{background:#e85e6c}.fc-time-area .fc-rows td>div{height:100px!important}.fc-highlightSelect{background-color:#4183c4;height:99px!important;margin-top:1px!important;margin-left:1px!important}.fc-eventCustom{background-color:red;border:1px solid #fff}.fc-holiday{background-color:#ccc}.module.customTable{padding-bottom:0;height:70vh;width:100%;overflow:auto;overflow-x:auto}.module.customTable .boxNoData{padding:3rem 0}.module.customTable .boxNoData p{font-weight:700}.module.customTable .ui.icon.button{padding:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.module.customTable .ui.icon.button .i.icon,.module.customTable .ui.icon.button i.icons{padding-right:2px!important;color:#e0e0e0}.module.customTable .ui.icon.button.btnUndo{background-color:#279b54;margin-right:5px;color:#fff}.module.customTable .ui.icon.button.btnDelete{background-color:#d1052c;margin-right:5px;color:#fff}.module.customTable .kQuRQn{height:52vh;padding-bottom:0!important;margin-bottom:0!important}.module.customTable .ktMXMg{height:100%}.module.customTable .hXqZQP{max-height:45vh}.module.customTable .brRDUc{padding-top:25px}.layoutHelper{text-align:left}.layoutHelper .helperKey{position:fixed;left:0;margin-left:10px;margin-top:-5px;display:inline-flex}.layoutHelper .helperKey.modal{position:unset}.layoutHelper .helperKey .keyGuide{margin-top:10px;font-size:16px;color:#000!important}.layoutHelper .helperKey .box-button{height:45px;width:60px;border:1px solid #d4d4d4;text-align:center;padding:2px;border-radius:2px;margin:0 5px}.layoutHelper .helperKey .box-button p{color:#000!important}.layoutHelper .helperKey .box-button p.iconKey{font-size:22px}.layoutHelper .helperKey .box-button p.iconKey.plus{font-size:30px}.layoutHelper .helperKey .box-button p.textKey{font-size:10px;margin-top:-5px}.actionsLeftHelperKey{padding-top:15px;text-align:left!important}.module.layoutWithSidebar .sidebarBox{position:fixed;display:flex;flex-direction:column;top:0;bottom:0;left:0;width:250px;background-color:#353386;overflow-x:hidden;flex:1}.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px;display:flex;justify-content:center;align-items:center;flex-direction:column}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox{max-width:230px;height:60px}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox img{height:100%;display:block}.module.layoutWithSidebar .sidebarBox .headerBox .text p{color:#353386;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox{border-top:1px solid #e6e7e8}.module.layoutWithSidebar .sidebarBox .actionBox .userBox p{color:#353386;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox{margin-top:10px}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox button{padding-top:5px;padding-bottom:5px;width:100%}.module.layoutWithSidebar .sidebarBox .headerBox{border-bottom:1px solid #353386}.module.layoutWithSidebar .sidebarBox .actionBox,.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px}.module.layoutWithSidebar .sidebarBox .menuBox{flex:1;overflow-y:auto}.module.layoutWithSidebar .bodyBox{margin-left:250px;min-width:550px;padding:2rem}.module.layoutWithSidebar .menuSidebar{width:100%;margin:0!important;min-height:unset;border:none;border-radius:unset}.module.layoutWithSidebar .menuSidebar .item{margin:0!important;color:#353386;font-weight:700;background-color:#353386;border-radius:unset!important}.module.layoutWithSidebar .menuSidebar .active.item,.module.layoutWithSidebar .menuSidebar .item:hover{border-radius:unset!important;color:#353386!important;background-color:#353386}.module.layoutWithSidebar .menuSidebar .active.item{margin:0!important;font-weight:700;cursor:unset!important}.module.layoutWithSidebar .menuSidebar .active.item:hover{border-radius:unset!important;color:#353386!important;background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar{width:10px;background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-thumb{border-radius:0;background-color:#353386;border:2px solid #353386}.layoutBlankMaster{background:transparent;height:100vh;display:flex;align-items:center;justify-content:center}.module.layoutBlank{width:100%;height:100vh}@media only screen and (min-width:0px) and (max-width:767px){.layoutBlank{padding:10px!important}}.module.layoutMaster,.module.layoutMaster .boxBody{background-color:#f9f9f9;height:100vh}.module.layoutMaster .boxBody{display:flex;flex:1;flex-direction:column}.module.layoutMaster .boxBody .boxHeader.expand{width:250px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage{width:100%;padding:5px;display:inline-flex;height:50px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem{width:30%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem img.ui.image,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem img.ui.image{margin-top:10px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem{width:70%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName{margin-top:-5px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName p{padding-top:5px;font-size:14px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .logout,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .logout{margin-top:-10px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText{margin-top:10px;font-weight:400;text-align:left}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText p{font-size:13px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom{left:140px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom p{padding-left:15px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom .language{padding-left:8px}.module.layoutMaster .boxBody .boxHeader.expand .item.logo img.ui.image{width:180px;height:40px}.module.layoutMaster .boxBody .boxHeader{position:fixed;left:0;z-index:200;height:100vh;width:85px;background-color:#f9f9f9;border-right:1px solid #ccc;box-shadow:3px 0 7px #ccc;border-top-right-radius:10px}.module.layoutMaster .boxBody .boxHeader .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:10px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader .item.logo img.ui.image{width:40px;height:40px}.module.layoutMaster .boxBody .boxHeader .item{height:50px;overflow:hidden;cursor:pointer;width:100%}.module.layoutMaster .boxBody .boxHeader .item .itemIcon,.module.layoutMaster .boxBody .boxHeader .item .userImage{width:100%;text-align:center;height:40px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon img.ui.image,.module.layoutMaster .boxBody .boxHeader .item .userImage img.ui.image{left:45%;transform:translate(-45%);width:30px;height:30px;border-radius:5px;margin-top:5px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .itemIcon .logout,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .logout{text-align:left}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName{font-weight:700;padding-top:5px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName p,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName p{text-overflow:ellipsis;white-space:nowrap;height:30px;overflow:hidden;width:20ch}.module.layoutMaster .boxBody .boxHeader .item i.icon{padding-top:5px;text-align:center;font-size:30px;margin:0}.module.layoutMaster .boxBody .boxHeader .item .logout{cursor:pointer}.module.layoutMaster .boxBody .boxHeader .item .logout p{font-size:12px}.module.layoutMaster .boxBody .boxHeader .item.active{background-color:#e8e8e8}.module.layoutMaster .boxBody .boxHeader .item.line{border-top:1px solid #ccc;width:100%;height:1px;padding:0}.module.layoutMaster .boxBody .boxHeader .item.bottom{position:fixed;left:0;bottom:0;display:inline-table;padding:0;padding-bottom:10px;width:250px}.module.layoutMaster .boxBody .boxHeader .item.bottom p{font-size:12px;padding-left:8px}.module.layoutMaster .boxBody .boxHeader .item.bottom .language img.ui.image{display:inline;width:25px}.module.layoutMaster .boxBody .boxContent{padding-bottom:50px;height:100vh}.module.layoutMaster .boxBody .boxContent .contentBox{background-color:#f9f9f9;padding-top:2rem;width:100%;padding-bottom:100px}.module.layoutMaster .boxBody .boxHeader.mobile{width:100vw;z-index:200;position:fixed;left:0;height:45px;background-color:#f9f9f9}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo img.ui.image{width:30px;height:30px}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:3px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader.mobile.expand{height:100%;width:80vw}.module.layoutMaster .boxBody .boxHeader.mobile.expand .item.bottom{height:100vh;top:80%;left:50vw}.module.layoutMaster .logoImageHeader img{width:8rem;margin:0;display:inline-flex}.layoutMasterWebsite{background:#fff;background-image:url(\"/assets/images/bg-doc-test3.png\");background-position:top,bottom;background-repeat:repeat-y;background-size:cover}.bg-main-cover,.layoutMasterWebsite{-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover}.bg-main-cover{background-image:url(\"/assets/images/bg-doc-test3.png\");background-position:top,bottom;background-repeat:repeat-y;background-size:cover;z-index:998}.module.layoutDisplay{width:100%;background:linear-gradient(90deg,#fffdfc 0,#fffdfc 50%,#f4caba 0,#f4caba);height:100vh;height:calc(var(--vh, 1vh) * 100);overflow-x:hidden;overflow-y:hidden;display:flex;justify-content:center;align-items:center;flex:1;padding:15px}.module.layoutDisplay .headerSection{position:absolute;top:0;height:5vh;width:100vw}.module.layoutDisplay .headerSection .headerText{padding-right:3vw;padding-top:1.2vh;text-align:right;font-size:1.8em;color:#fff}.module.layoutDisplay .contentSection{width:100%}.module.layoutDisplay.backgroundBlack{background-color:#111a26}.module.layoutPD{background-color:#fff;height:100vh;height:calc(var(--vh, 1vh) * 100);display:flex;justify-content:center;flex:1;padding:24px 40px}.module.layoutPD .headerSection{position:absolute;top:0;height:5vh;width:100vw}.module.layoutPD .headerSection .headerText{padding-right:3vw;padding-top:1.2vh;text-align:right;font-size:1.8em}.module.layoutPD .contentSection{width:100%}.module.layoutDisplay.backgroundBlack{background-color:#fff}.wrapperNavBarDomain{background:#f8dbd0;width:98%;padding:12px;height:5vh;border-radius:4px;display:flex;justify-content:space-between;align-items:center}.wrapperNavBarDomain .navTextLogo{font-weight:700;font-size:18px;display:flex;align-items:center;cursor:pointer}.wrapperNavBarDomain .navTextLogo p{color:#737b88}.wrapperNavBarDomain .navTextLogo .globe{margin-bottom:3px;margin-right:4px}.wrapperNavBarDomain .action{display:flex;justify-content:flex-end;align-items:center}.wrapperNavBarDomain .action p{color:#737b88;font-size:12px;margin-right:12px}.wrapperNavBarDomain .action .user{margin-bottom:10px;margin-right:4px}.wrapperNavBarDomain .action .out{cursor:pointer;color:#e99778}.wrapperNavBarDomain .action .out:hover{color:#f8dbd0;background-color:#e99778}.mainForm{display:flex;flex-direction:column;justify-content:center;align-items:center;color:#000;font-size:1rem!important;font-weight:400!important;padding:10px}.mainForm .secondForm{border:1px solid #e9ecef!important;border-radius:8px!important;box-shadow:0 1px 3px 0 #e9ecef!important;padding:24px!important;background:#bababa29!important;width:100%}.mainForm .secondForm .uploadForm .uploadSingleFile{margin-left:-10px}.saveButton{background-color:#475569!important;color:#fff!important;font-weight:300!important;padding:10px!important}.saveButton:hover{background-color:#35404f!important;color:#fff!important}.cancelButton{background-color:#e4c203!important;color:#fff!important;font-weight:300!important;padding:10px!important}.cancelButton:hover{background-color:#d1b203!important;color:#fff!important}.backButton{font-weight:300!important;padding:10px!important}.backButton,.backButton:hover{background-color:#e53e3e!important;color:#fff!important}.iconDelete{display:flex!important;justify-content:center!important;margin-bottom:40px!important;padding:12px!important;background-color:#fca5a5!important;cursor:pointer!important}.iconDelete:hover{background-color:red!important;color:#fff!important}.iconAdd{display:flex!important;align-items:center!important;justify-content:center!important;margin-bottom:40px!important;padding:12px!important;background-color:#bae6fd!important;cursor:pointer!important}.iconAdd:hover{background-color:#0369a1!important}.uploadFile{background-color:#fff!important;color:#000!important;font-weight:400!important;padding:5px!important;font-size:16px!important;border:1px solid #000!important;margin-left:5px!important}.uploadFile:hover{background-color:#6d7699!important;color:#fff!important}.add{background-color:#475569;color:#fff!important;font-weight:400!important;height:43px;border-radius:4px!important;font-size:14px!important;margin-bottom:0!important}.add:disabled{color:#35404f!important}h2{color:#000;margin-bottom:10px;margin-top:10px}.ui.checkbox+label,.ui.checkbox label{color:#000!important}.ui.form .field>label{font-size:14px!important}h1{font-size:20px}h2{font-size:18px}h3{font-size:16px}.receiver,.sender{border:2px solid #e9ecef;border-radius:12px;padding:20px}.sender{margin-top:12px}.doc-card{border:1px solid #e9ecef!important;border-radius:8px!important;box-shadow:0 1px 3px 0 #e9ecef!important;padding:24px!important;margin-bottom:12px;background:#fff!important}.select-user-components{display:flex;flex-direction:row}.select-user-components .field{display:flex;flex-direction:column}.select-user-components .field label{font-size:14px!important}.select-user-components .field input{height:43px}.modal-assets td,.modal-assets th{font-size:12px!important}@media screen and (max-width:768px){.mainForm{padding:0 0 8px!important}.mainForm .secondForm{padding:8px!important}.table-asset tr{display:flex!important}.doc-card{padding:6px}}.guideLine .color1,.guideLine .loginBtn{background-color:#4879ed}.guideLine .color2{background-color:#dfe5f5}.guideLine .color3{background-color:#0f182a}.guideLine .color4{background-color:#a6a5a5}.guideLine .color5{background-color:#e1e2e3}.guideLine .color6{background-color:#f7f7f7}.guideLine .Line{border:.5px solid #e2e2e2;padding-bottom:20px!important;margin-top:8px!important}.guideLine .colorFont1{background-color:#0f182a}.guideLine .colorFont2{background-color:#a6a5a5}.slideshow-container .text{color:#f2f2f2;font-size:15px;padding:8px 12px;position:absolute;bottom:8px;width:100%;text-align:center}.slideshow-container .numbertext{color:#f2f2f2;font-size:12px;padding:8px 12px;position:absolute;top:0}.slideshow-container .dot{cursor:pointer;height:15px;width:15px;margin:0 2px;background-color:#bbb;border-radius:50%;display:inline-block;transition:background-color .6s ease}.slideshow-container .active,.slideshow-container .dot:hover{background-color:#717171}.slideshow-container .fade{animation-name:fade;animation-duration:1.5s}.react-3d-carousel .slider-container .slider-left div,.react-3d-carousel .slider-container .slider-right div{border:0!important}.imageSlide,.react-3d-carousel .slider-container .slider-content .slider-single .slider-single-content img{width:100px I!important}.imageSlide{display:flex;align-items:center!important;background-color:none!important;border:0!important}@keyframes bounce{0%,20%,50%,80%,to{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}40%{-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px)}60%{-webkit-transform:translateY(-5px);-ms-transform:translateY(-5px);transform:translateY(-5px)}}button.baseBtn{color:#fff;transition:all .12s ease-in-out!important;outline:0 solid #fff!important;display:flex;justify-content:center;align-items:center;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite}button.baseBtn:hover{animation-name:bounce;-moz-animation-name:bounce}button.baseBtn .wrapperIconBtn{background:#fff;border-radius:100%!important;width:30px;height:30px;display:flex;justify-content:center;align-items:center}button.baseBtn .wrapperContentBtn{display:flex;justify-content:center;align-items:center;min-height:30px;line-height:normal!important}button.baseBtn .MuiButton-label{display:flex!important;flex-direction:row;justify-content:space-between!important}button.baseBtn .textBtn{margin:0 14px;font-weight:600}button.baseBtn .MuiSvgIcon-root{font-size:20px!important}.btnBlue.baseBtn.right{float:right}@-webkit-keyframes show{0%{opacity:0}to{opacity:1}}:disabled{cursor:not-allowed!important;background-color:#eaeaea!important;color:#c6c6c6;filter:alpha(opacity=65);box-shadow:none;opacity:.65;pointer-events:all!important;transform:translateY(0)!important;outline:0 solid #fff!important}.btnRed{background:#f48882!important}.btnRed .wrapperIconBtn{box-shadow:2px 0 6px #ee453c}.btnRed:focus,.btnRed:hover{box-shadow:0 10px 10px -.4em #ee453c;background:#ee453c!important}.btnRed:focus .textBtn,.btnRed:hover .textBtn{color:#fff!important;opacity:1!important}.btnGreen{background:rgba(79,251,119,.870588)!important}.btnGreen .wrapperIconBtn{box-shadow:2px 0 6px rgba(65,219,101,.870588)}.btnGreen:focus,.btnGreen:hover{box-shadow:0 10px 10px -.4em rgba(65,219,101,.870588);background:rgba(65,219,101,.870588)!important}.btnGreen:focus .textBtn,.btnGreen:hover .textBtn{color:#fff!important;opacity:1!important}.btnBlue{background:#8ab2e4!important}.btnBlue .wrapperIconBtn{box-shadow:2px 0 6px #4478b5}.btnBlue:focus,.btnBlue:hover{box-shadow:0 10px 10px -.4em #4478b5;background:#4478b5}.btnBlue:focus .textBtn,.btnBlue:hover .textBtn{color:#fff!important;opacity:1!important}.btnPurple{background:linear-gradient(90deg,#eac3e2,#dd9bcf 35%,#ca62b4);background:#dd9bcf!important}.btnPurple .wrapperIconBtn{box-shadow:2px 0 6px #ca62b4}.btnPurple:focus,.btnPurple:hover{box-shadow:0 10px 10px -.4em #ca62b4;background:#ca62b4!important}.btnPurple:focus .textBtn,.btnPurple:hover .textBtn{color:#fff!important;opacity:1!important}.btnYellow{background:#f1f699 35%!important}.btnYellow .wrapperIconBtn{box-shadow:2px 0 6px #e7f053}.btnYellow:focus,.btnYellow:hover{box-shadow:0 10px 10px -.4em #e7f053;background:#e7f053 35%!important}.btnYellow:focus .textBtn,.btnYellow:hover .textBtn{color:#fff!important;opacity:1!important}.btnPeach{background:#fad2cc!important}.btnPeach .wrapperIconBtn{box-shadow:2px 0 6px #f39586}.btnPeach:focus,.btnPeach:hover{box-shadow:0 10px 10px -.4em #f39586;background:#f39586!important}.btnPeach:focus .textBtn,.btnPeach:hover .textBtn{color:#fff!important;opacity:1!important}.btnGray{background:#b4b4b4!important}.btnGray .wrapperIconBtn{box-shadow:2px 0 6px #9a9a9a}.btnGray:focus,.btnGray:hover{box-shadow:0 10px 10px -.4em #9a9a9a;background:#9a9a9a!important}.btnGray:focus .textBtn,.btnGray:hover .textBtn{color:#fff!important;opacity:1!important}.btnSky{background:#ccf4fa!important}.btnSky .wrapperIconBtn{box-shadow:2px 0 6px #9eeaf5}.btnSky:focus,.btnSky:hover{box-shadow:0 10px 10px -.4em #9eeaf5;background:#9eeaf5!important}.btnSky:focus .textBtn,.btnSky:hover .textBtn{color:#fff!important;opacity:1!important}.btnSoftGreen{background:#c6fad2!important}.btnSoftGreen .wrapperIconBtn{box-shadow:2px 0 6px #80f49a}.btnSoftGreen:focus,.btnSoftGreen:hover{box-shadow:0 10px 10px -.4em #80f49a;background:#80f49a!important}.btnSoftGreen:focus .textBtn,.btnSoftGreen:hover .textBtn{color:#fff!important;opacity:1!important}.btnWhite{background:#fff!important}.btnWhite .wrapperIconBtn{box-shadow:2px 0 6px #e2e2e2}.btnWhite:focus,.btnWhite:hover{box-shadow:0 10px 10px -.4em #e2e2e2;background:#eee}.btnOrange{background:#ffa995!important}.btnOrange .wrapperIconBtn{box-shadow:2px 0 6px #d68e5e}.btnOrange:focus,.btnOrange:hover{box-shadow:0 10px 10px -.4em #d68e5e;background:#ffa66b}.btnOrange:focus .textBtn,.btnOrange:hover .textBtn{color:#fff!important;opacity:1!important}.bounceAnim{transition:all .12s ease-in-out!important;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite}.bounceAnim:hover{animation-name:bounce;-moz-animation-name:bounce}.btnBackToTop{background:#8ab2e4!important;width:40px!important;height:40px!important;border-radius:100%!important;max-width:40px!important;min-width:40px!important;position:absolute!important;bottom:10px!important;right:20px!important;transition:all .12s ease-in-out!important;display:flex;border:1px solid #8ab2e4!important;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite}.btnBackToTop:hover{animation-name:bounce;-moz-animation-name:bounce;border:1px solid #fff!important;box-shadow:0 10px 10px -.4em #4478b5}.textToTopBtn{display:none}.logoutWrapper:before{left:unset!important;right:3em!important}.wrapperIconBtnChat{background:#fff;border-radius:100%!important;width:35px;height:35px;display:flex;justify-content:center;align-items:center;box-shadow:2px 0 6px #e2e2e2}@media screen and (max-width:768px){.document-button button.baseBtn{width:100%!important;display:flex;margin-bottom:4px}.document-button button.baseBtn .MuiButton-label .textBtn{width:50%;display:flex;justify-content:flex-start}}.wrapper-loading-text .wrap-text{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);padding:12px 48px;color:#fff;background:linear-gradient(90deg,#4d4d4d 0,#fff 10%,#4d4d4d 20%);background-position:0;-webkit-background-clip:text;-webkit-text-fill-color:transparent;animation:shine 3s infinite linear;animation-fill-mode:forwards;-webkit-text-size-adjust:none;font-weight:600;font-size:16px;text-decoration:none;white-space:nowrap}@keyframes shine{0%{background-position:0}60%{background-position:180px}to{background-position:180px}}.ql-container,.ql-toolbar{background:#fff!important}.ql-container .ql-editor,.ql-toolbar .ql-editor{min-height:270px;overflow-y:auto}.ql-container .ql-editor h1,.ql-toolbar .ql-editor h1{font-size:22px!important}.ql-container .ql-editor h2,.ql-toolbar .ql-editor h2{font-size:20px!important}.ql-container .ql-editor h3,.ql-toolbar .ql-editor h3{font-size:16px!important}.ql-container .ql-editor p,.ql-toolbar .ql-editor p{font-size:14px!important}.ql-disabled{background:#eaeaea!important}.user-card-template{background:linear-gradient(230deg,hsla(0,9%,98%,.95) 9%,hsla(0,2%,88%,.38) 31%,hsla(0,0%,94%,0))!important}.user-card-template .user-card-image{transition:all}.user-card-template:hover{cursor:pointer}.user-card-template:hover .user-card-image{transition-duration:.5s;transform:scale(1.15)}.container-tab-select{max-height:calc(100vh - 300px);overflow-x:auto;height:100vh}.search-date-document label{margin:0 4px!important}.table-body-non-overflow-y{overflow-y:unset!important}.announceText p{font-size:12px}@media screen and (min-width:0px) and (max-width:768px){.container-tab-select{max-height:100%;overflow-x:auto}.search-date-document .input{width:100%!important}}@media screen and (min-width:1919px){.wrapper-navbar-top{margin:0 auto;width:1920px}}.afterTextRequire:after{content:\" *\";color:#db2828}.pulseEff{z-index:9999!important;box-shadow:0 0 0 0 #000;transform:scale(1);animation:pulse 2s infinite}@keyframes pulse{0%{transform:scale(.95);box-shadow:0 0 0 0 rgba(0,0,0,.7)}70%{transform:scale(1);box-shadow:0 0 0 10px transparent}to{transform:scale(.95);box-shadow:0 0 0 0 transparent}}.marquee{width:100%;line-height:50px;white-space:nowrap;overflow:hidden;box-sizing:border-box}.marquee p{font-size:12px;display:inline-block;padding-left:100%;animation:marquee 15s linear infinite}@keyframes marquee{0%{transform:translate(0)}to{transform:translate(-100%)}}", ""]);

// exports


/***/ }),

/***/ 109:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"OK","cancel":"Cancel","back":"Back","welcome":"Welcome","hello":"Hello","somethingWrong":"Something Went Wrong, Please Try Again.","yourData":"Confirm Your Information.","validateError":"Validate error, Please fill in all require data.","validateCommentError":"Please enter a comment","attachError":"Upload error, Please choose file","fileError":"Upload error, Please choose file type pdf, jpg, png","squareInch":"SQUARE INCH","version":"Version","profile":"profile","logout":"Log out","npiSystem":"NPI System","pageNotFound":"Page not found, Please re-check your url again.","unauthen":"Unauthorized, Please contact administrator for request access.","success":"Success","fail":"Fail","itemCode":"Item Code","itemStatus":"Item Status","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","right":"Right","left":"Left","edit":"Edit","reject":"Reject","search":"Search","lastUpdateBy":"Last Update by","create":"Create","view":"View","update":"Update","value":"Value","createFail":"Create Fail","updateFail":"Update Fail","upload":"Upload","comment":"Comment","close":"Close","confirm":"Confirm","save":"Save","chooseOptions":"Choose an option","add":"Add","submit":"Submit","transfer":"Transfer","scan":"Scan","receive":"Receive","deleteBy":"Delete By","print":"Print","duplicate":"Duplicate","enter":"Enter","scanId":"Scan ID for Booking","waitingForManager":"Waiting for Manager...","breakSection":"Break, Please Scan ID for Start","clearPD":"Clear PD","clearWorker":"Clear Worker","pdListAlert":"PD List Warning","workerListAlert":"Worker List Not Exist on System","delete":"Delete","pleaseContactAdminAx":"Please Contact AX Admin","pleaseCheckData":"Please Check Data","pleaseSelect":"Please Select Item","select":"Select","addRM":"Add RM","noWorker":"No Worker","noJobList":"No Job List","redirectPage":"Redirect Page","list":"List","areYouSureDelete":"Are you sure to cancel this request?. Please enter a reason.","areYouSureRemove":"Are you sure to remove this item?","areYouSureConfirm":"Are you sure to confirm this request?","areYouSureReject":"Are you sure to reject this request?. Please enter a reason","manage":"Manage","default":"Default","favorite":"Favorite","seeMore":"See More","noAssetCode":"No Asset Code","clearSearch":"Clear","users":"Users","total":"Total","selectUser":"Select User","firstName":"First Name","lastName":"Last Name","empId":"Emp Id","position":"Level","controlPosition":"Change","requestApprove":"Request Approve","setOkr":"Set Okr","noApproval":"No Approval","noAdmin":"No Admin","canCreateOkr":"Create","canEditOkr":"Edit","canDeleteOkr":"Delete","canChangeProgressOkr":"Change Progress","permissionOkr":"Permission","updateImage":"Update Logo Banner","adminMenuSetting":"Admin Menu Setting","uploadLogo":"Upload Logo","uploadBanner":"Upload Banner","checkConnectO365":"Check Connect O365","checkConnectAX":"Check Connect AX","male":"Male","female":"Female","other":"Other","placeholderText":"Confirm text..","confirmDelete":"Are you sure you want to delete?","firstTextDelete":"Input text ","lastTextDelete":"for delete!","checkText":"Confirm text not match!","confirmSave":"Do you want to save it?","confirmAll":"Do you want to save all changes?","reportBug":"Bug hunter form","nameTh":"Name TH","nameEn":"Name EN","announce":"Announcement","announceBodyTh":"Announcement TH","announceBodyEn":"Announcement EN","announceType":"Announce Type","lastLogin":"No. recent logins (24h) : ","selectItem":"Select ","description":"Description","cost":"Cost","noData":"No data","userGroupNotFound":"UserGroupNotFound","active":"Active","YieldToday":"Yield today","YieldMonth":"Yield this month","TotalYield":"Total yield","RevenueToday":"Revenue today","TotalRevenue":"Total Revenue","capacity":"Plant Capacity","activePower":"Active Power","id":"Id","sn":"SN","nameDevice":"Name Device","listDevice":"List Device","stationCode":"Station Code","typeId":"Type Id","voltage":"Voltage","frequency":"Frequency","current":"Current","ampere":"Ampere","companySetting":"Company Setting","changeImage":"Change Image","stationNotFound":"Station Not Found","home":"Home","dashboard":"Dashboard","map":"Map","refresSetting":"Refresh Setting","adminSetting":"Admin Setting","site":"Site","station":"Station","userGroup":"User Group","user":"User","device":"Device","setTimeToRefresh":"Set time to refresh","min":"min","company":"Company","report":"Report","pleaseSelectTheInformationYouWant":"Please select the information you want.","downLoad":"Download Excel","fromDate":"From date","toDate":"To date","allDevice":"All Device","status":"Status","overView":"Overview","logoCompany":"Logo Company","imageDiagram":"Image Diagram","imageSite":"Image Site","administrator":"Administrator","running":"Running","softwareVersion":"Software version","model":"Model","deviceType":"Device Type","loading":"Loading...","noImage":"No image","warning":"Warning: this website demo will expire ,1/5/2024 please contact seller"}}

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

module.exports = {"login":{"signinNormal":"Login","email":"Email","Password":"Password","login":"Login","ForgotPassword":"Forgot password?","somethingWrong":"Something Went Wrong, Please Try Again.","yourData":"Confirm Your Information.","validateError":"Validate error, Please fill in all require data.","validateCommentError":"Please enter a comment","attachError":"Upload error, Please choose file","fileError":"Upload error, Please choose file type pdf, jpg, png","squareInch":"SQUARE INCH","version":"Version","profile":"profile","logout":"Log out","send":"Send","npiSystem":"NPI System","pageNotFound":"Page not found, Please re-check your url again.","unauthen":"Unauthorized, Please contact administrator for request access.","success":"Success","fail":"Fail","itemCode":"Item Code","itemStatus":"Item Status","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","right":"Right","left":"Left","edit":"Edit","reject":"Reject","search":"Search","lastUpdateBy":"Last Update by","create":"Create","view":"View","update":"Update","value":"Value","createFail":"Create Fail","updateFail":"Update Fail","upload":"Upload","comment":"Comment","close":"Close","confirm":"Confirm","save":"Save","chooseOptions":"Choose an option","add":"Add","submit":"Submit","transfer":"Transfer","scan":"Scan","receive":"Receive","deleteBy":"Delete By","print":"Print","duplicate":"Duplicate","enter":"Enter","scanId":"Scan ID for Booking","waitingForManager":"Waiting for Manager...","breakSection":"Break, Please Scan ID for Start","clearPD":"Clear PD","clearWorker":"Clear Worker","pdListAlert":"PD List Warning","workerListAlert":"Worker List Not Exist on System","delete":"Delete","pleaseContactAdminAx":"Please Contact AX Admin","pleaseCheckData":"Please Check Data","pleaseSelect":"Please Select Item","select":"Select","addRM":"Add RM","noWorker":"No Worker","noJobList":"No Job List","redirectPage":"Redirect Page","list":"List","areYouSureDelete":"Are you sure to cancel this request?. Please enter a reason.","areYouSureRemove":"Are you sure to remove this item?","areYouSureConfirm":"Are you sure to confirm this request?","areYouSureReject":"Are you sure to reject this request?. Please enter a reason","manage":"Manage","default":"Default","favorite":"Favorite","seeMore":"See More","noAssetCode":"No Asset Code","clearSearch":"Clear","users":"Users","total":"Total","selectUser":"Select User","firstName":"First Name","lastName":"Last Name","empId":"Emp Id","position":"Level","controlPosition":"Change","requestApprove":"Request Approve","optAgain":"Request OTP again","setOkr":"Set Okr","noApproval":"No Approval","noAdmin":"No Admin","canCreateOkr":"Create","canEditOkr":"Edit","canDeleteOkr":"Delete","canChangeProgressOkr":"Change Progress","permissionOkr":"Permission","updateImage":"Update Logo Banner","adminMenuSetting":"Admin Menu Setting","uploadLogo":"Upload Logo","uploadBanner":"Upload Banner","checkConnectO365":"Check Connect O365","checkConnectAX":"Check Connect AX","male":"Male","female":"Female","other":"Other","placeholderText":"Confirm text..","confirmDelete":"Are you sure you want to delete?","firstTextDelete":"Input text ","lastTextDelete":"for delete!","checkText":"Confirm text not match!","confirmSave":"Do you want to save it?","confirmAll":"Do you want to save all changes?","reportBug":"Bug hunter form","nameTh":"Name TH","nameEn":"Name EN","announce":"Announcement","announceBodyTh":"Announcement TH","announceBodyEn":"Announcement EN","announceType":"Announce Type","lastLogin":"No. recent logins (24h) : ","selectItem":"Select ","description":"Description","cost":"Cost"}}

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

module.exports = {"menu":{"site":"Site","userGroup":"User Group","user":"User"}}

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

module.exports = {"settings":{"nameEn":"Name En","nameTh":"Name Th","address":"Address","email":"E-mail","groupName":"Name","groupCode":"Code","groupDescription":"Description","stationIds":"Station","firstName":"First Name","lastName":"Last Name","age":"Age","password":"Password","userGroupId":"User Group","companyId":"Company","siteId":"Site","station":"Station","add":"Add","stationName":"Station Name","siteName":"Site Name","status":"Status"}}

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data","welcomeText":"Welcome"}}

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

module.exports = {"purchase":{"sellerRegister":"Seller Register","request":"Request","agency":"Agency","purchaseName":"Purchase Name","dateRequested":"Date Requested","purpose":"Purpose","project":"Project","vendorAccount":"VendorAccount","costcentor":"Costcentor","site":"Site","companyAddress":"CompanyAddress","currency":"Currency","description":"Description","branch":"Branch","agencyCode":"Agency Code","nameTh":"Seller name  (TH) ","nameEn":"Seller name (EN) ","contact":"Contact","email":"Email","tax":"Tax Number (Individuals specify ID card number)","purchasePart":"Purchase","sellerGroupItem":"Seller group items (by vendor or material group)","sellerHeader":"Seller infomation","document":"Document","poId":"Purchase order ID"},"npi":{"date":"Date","productType":"Product Type","productNumber":"Product Number","productName":"Product Name","searchName":"Search Name","itemModelGroup":"Item Model Group","itemGroup":"Item Group","itemSaleStax":"Item Sale Stax(Sales)","itemSalesPurchase":"Item Sales Purchase(Purchase)","storageDimansionGroup":"Storage Dimansion Group","trackingDimansionGroup":"Tracking Dimansion Group","buyerGroup":"Buyer Group","purchaseUnit":"Purchase Unit","salesUnit":"Sales Unit","bomUnit":"Bom Unit","vender":"Vender","venderItemNumber":"Vender Item Number","inventoryUnit":"Inventory Unit","section":"Section"},"hr":{"timeStart":"Start Time","timeEnd":"End Time"},"core":{"requesterCode":"Requester Code","title":"Title","value":"Cost","approvalHierarchy":"Approval hierarchy (Ordered from top to bottom)","member":"Member","project":"Project","destinationRecipient":"Destination recipient (The system will send an email to everyone)","conditionsForRecipients":"Conditions For Recipients","allAprove":"Yes(In case of wanting all recipients to accept, they must click to acknowledge to finish the document.)","oneApprove":"No (in case you want one of the recipients to click to acknowledge to end the document)","company":"Company","recipient":"Recipient","sender":"Sender","removeDate":"Date of removal","propertytype":"Property Type","quantity":"Quantity","reason":"Reason","serialNumber":"Serial Number"},"generalAdmin":{"date":"Date","agencyCode":"Agency Code","agency":"Agency","team":"Team","departmentTranferAssest":"Department to transfer assets","departmentReceivesProp":"Department that receives the Property","specifyItem":"Specify the item to be transferred to the transferee.","tranferApprove":"I am the transferor agreeing to transfer the following assets and the transferee agreeing to accept the transfer of such items Please be informed accordingly to proceed with the transfer.","Requisitioner":"Requisitioner","forWork":"For use in work(new Requisition)","forReplace":"For replacing the original that was damaged","description":"Description","add":"Add","purpose":"Purpose of work","requesterCutPropCode":"Code of the person requesting to cut off the property","propertyCode":"Property Code","propertyName":"Property Name","employeeCode":"Emp Code","fullName":"Full Name","sequence":"No.","purchasedOn":"Purchased On","priceOnPurchaseDate":"Price On Purchase Date","residualValue":"Residual Value","itemId":"ITEM ID","itemName":"ITEM NAME","onHandQty":"ONHAND QTY","qty":"QTY","siteId":"SITEID","wareHouse":"WAREHOUSE","requesterCode":"Requester Code","assetCode":"Code","assetName":"Asset name","assetDes":"Asset description","assetDesTH":"Asset description (Th)","assetDesEN":"Asset description (En)","currentPrice":"Current price","pricePerPeice":"Price per peice","assetPrice":"Price / Unit","totalInStock":"Total in stock","totalUsed":"Used","total":"Total","reqQty":"Qty","purchaseDate":"Purchase date","select":"Select","clickMeForSelectAsset":"Click Me! for select asset.","selectBeforSubmit":"Choose at least 1 item before submit.","assetNo":"Asset No","detail":"Detail","spec":"Spec","discountPercent":"Discount percent","totalBeforeDiscount":"Total beforeDiscount","discountNumber":"Discount Number","instock":"in stock","action":"Action"},"it":{"requestUser":"Request User Computer","requester":"Requester","agencycode":"Agency Code","agency":"Agency","description":"Description","lsicense":"License","adcode":"AD code","adname":"AD name","expenses":"Expenses","sum":"Sum","attachdocuments":"Attach Documents","upload":"Upload","save":"Save","hardware":"Hardware equipment requisition document","requesto":"Reques To","deviceID":"Device ID","name":"Name","add":"Add","requesrightsto":"Reques To","purposeofuse":"Purpose Of Use","forwork":"For use in work (new draw)","forreplacing":"For replacing the original that was damaged","type":"Type","preview":"Preview","download":"Download","createby":"Create By","test":"test","close":"Close"},"finance":{"partyType":"PartyType","startDate":"Start Date","requester":"Requester","agencyCode":"Agency Code","agency":"Agency","customerStatus":"Customer Status","customerCode":"Customer Code","Pleaseenter":"input here...","firstName":"FirstName","lastName":"LastName","taxpayerIdentificationNumber":"Taxpayer identification number","company":"Company","customerGroup":"Customer Group","paymentTerm":"Payment Term","deliveryTerm":"Delivery Term","deliveryMode":"Delivery Mode","country":"Country","details":"details","customerAddress":"Customer address","condition":"Conditions or regulations for billing and receiving checks (Documents from customers)","billingPlace":"Billing place","contactName":"Contact name","telephoneNumber":"Telephone number","PlacReceiveChecks":"Place to receive checks","BillingDocuments":"What are the documents required for billing?","CheckReceiptDocument":"What are the supporting documents for receiving a check?","payType":"PayType","creditLine":"Credit line","creditPeriod":"Credit period","mandatory":"Mandatory","ApprovalReason":"Reason for approval","documentsTypes":"Types of withdrawal request documents","projectName":"Project name","projectDetail":"Project detail","workValue":"Work value","objectivesReception":"Objectives Reception","nameSurname":"Name - Surname","contactFullName":"Fullname","position":"Position","note":"Note","ceremonyOn":"Ceremony on","Amount(Baht)":"Amount (Baht)","receptionResults":"Reception Results","acceptDocument":"I hereby certify that it is all true."},"all":{"upload":"UPLOAD","workflowstatus":"Work flow status","save":"SAVE","attachDocuments":"Attach Documents","add":"Add","waitLoading":"Please wait we're loading detail."},"fileUpload":{"fileName":"File name","fileType":"File type","fileSize":"file size"},"comment":{"empId":"Emp Code","commentBy":"Comment by","msg":"Comment","createDate":"Create date","selectViewer":"Select viewer","addToComment":"Add to comment","deleteToComment":"Remove to comment"},"task":{"task":"Task","title":"Title","documentNumber":"Document Number","doc":"Document Detail","additional":"See additional document details."},"ncReport":{"ncReport":"Nonconforming Found Report","pdRef":"PD (CIG Ref) ","non":"Nonconforming Found Report","status":"Nonconforming product type and status","unit":"The unit that found the defect","drwNo":"DRW. No.","coilNo":"COIL.No.","coilSize":"Coil Size","nonCompliance":"Characteristics of non-compliance","specifications":"Product specifications","agency":"Products that do not conform to specifications occur at the agency","found":"Found at the agency","cause":"It is the cause of","operator":"Operator","operation":"Operation","release":"Release","reasonConditions":"Conditions/reasons for approval","approval":"Applicant for approval","partiesAgree":"Parties agree","sales":"Sales department","planning":"Planning Department","production":"Production Department","npl":"NPL Department","qa":"Acknowledged by QA department","customer":"Customers accept non-conforming products based on evidence. consent letter","fQa":"F-QA-02-21 No.","use":"Date the results of use/delivery","verifier":"Verifier","date":"Date","rework":"Rework","way":"Way","qaDepartment":"QA department","action":"Action","operating":"Operating agency","proceed":"How to proceed","wasteGenerated":"Waste Generated","aluminum":"aluminum / Kg.","copper":"Copper / Kg.","plate":"Plate / Kg.","dateCompleted":"Date completed","modifier":"Modifier","verification":"Result of revised product verification","inspector":"Production department, release inspector","unitQa":"Q.C. unit","reject":"Reject","approve":"Approve and choose the method of operation.","manager":"Department Manager/Production Department","managerQa":"Department Manager/QA Department","mo":"Issue a new production order (MO.) for replacement production.","quantity":"Quantity (pieces / per)","pd":"PD","fin":"1P-FIN Quantity (pieces / per)","cu":"1P-CU Quantity (pieces / per)","pla":"1P-PLA Quantity (pieces / per)","hd":"1P-HD-CU Quantity (pieces / per)","ass":"1P-ASSCoil Quantity (pieces / per)","bra":"1P-BRA Quantity (pieces / per)","pack":"1P-PACK Quantity (pieces / per)","replacement":"The replacement agency","processingDate":"Processing date","completionDate":"Actual completion date","personAppov":"The person who approves the action (Department Manager/Production Department)","branch":"Branch","orderPd":"Production order number PD","reference":"PD reference number","productionOrder":"Production order quantity","quantityPd":"Quantity that must be produced in replacement","reasonPd":"Reason for replacement","NcrPdNumber":"NCR certificate number","inch":"cubic inch","agenciesPD":"Agencies that must open replacement production orders","substitutePd":"Substitute petitioner","because":"Please specify reason...","dateNCR":"NCR issue date","ncPdNumber":"NC.PD.No","ncrNumber":"NCR No.","ncName":"Reporter's name","dateReport":"Report date","shiftTimeReport":"Shift report","productOrderNumber":"Production order number (MO.)","manufactureNumber":"Production order quantity","problemNumber":"Number of problems encountered","priceInprocess":"Price-Inprocess","priceReadymade":"Price-Readymade","productInprocess":"Product-Inprocess","productReadymade":"Product-Readymade","meterial":"Meterial","method":"Method","machine":"Machine","person":"Person"},"im":{"expireDate":"Expire Date (mm/dd/yyyy)","inspectionWeight":"Roll/Net Weight","palleteTotal":"Pallete Total (Kg.)","netWeight":"Net Weight (Kg.)","package":"Package No./Coil No.","Type":"Raw Material/Accessory Type","Result":"Result","qaResult":"Incoming Inspection Result","receive":"Receive to store","defect":"Number of defective points","location":"Location","vendInvoice":"Invoice Number","receiptDate":"Receipt Date","receiptNumber":"Receipt Number","searchPO":"Search PO","itemId":"Part Number","itemType":"Item type","itemName":"Part Name","vendor":"Supplier Name","spacialReceivePerson":"Person approves receipt in special cases"}}

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"ตกลง","cancel":"ยกเลิก","back":"กลับ","welcome":"ยินดีต้อนรับ","hello":"สวัสดี","somethingWrong":"เกิดความผิดพลาด ลองใหม่อีกครั้ง","yourData":"ข้อมูลที่จะทำการบันทึก","validateError":"ไม่สามารถทำรายการต่อไปได้ กรุณากรอกข้อมูลให้ครบถ้วน","validateCommentError":"กรุณาแสดงความคิดเห็น","attachError":"ไม่สามารถอัพโหลดไฟล์ได้ เนื่องจากท่านยังไม่ได้ทำการเลือกไฟล์","fileError":"ไม่สามารถอัพโหลดไฟล์ได้ กรุณาเลือกไฟล์ pdf, jpg, png","squareInch":"SQUARE INCH","version":"เวอร์ชัน","profile":"ประวัติส่วนตัว","logout":"ออกจากระบบ","npiSystem":"ระบบ NPI","pageNotFound":"ไม่พบข้อมูล กรุณาตรวจสอบ url อีกครั้ง","unauthen":"ไม่มีสิทธิเข้าใช้งาน, กรุณาติดต่อเจ้าหน้าที่ เพื่อขอสิทธิใช้งาน","success":"สำเร็จ","fail":"ไม่สำเร็จ","itemCode":"รหัสรายการ","itemStatus":"สถานะ","code":"รหัส","name":"ชื่อ","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"ยืนยัน","no":"ยกเลิก","left":"Left","right":"Right","edit":"Edit","reject":"Reject","search":"ค้นหา","lastUpdateBy":"แก้ไขโดย","create":"เพิ่ม","view":"ดูรายละเอียด","update":"แก้ไข","value":"Value","createFail":"บันทึกไม่สำเร็จ","updateFail":"ปรับปรุงไม่สำเร็จ","upload":"อัพโหลด","comment":"ส่งข้อความ","close":"ปิด","confirm":"ยืนยัน","save":"บันทึก","chooseOptions":"Choose an option","add":"Add","submit":"ยืนยัน","transfer":"Transfer","scan":"Scan","receive":"Receive","deleteBy":"ลบโดย","print":"พิมพ์","duplicate":"Duplicate","enter":"Enter","scanId":"Scan ID for Booking","waitingForManager":"Waiting for Manager...","breakSection":"อยู่ระหว่างพัก กรุณาแตะบัตรเพื่อเริ่มการทำงานอีกครั้ง","clearPD":"Clear PD","clearWorker":"Clear Worker","pdListAlert":"PD List Warning","workerListAlert":"Worker List Not Exist on System","delete":"Delete","pleaseContactAdminAx":"Please Contact AX Admin","pleaseCheckData":"Please Check Data","pleaseSelect":"Please Select Item","select":" Select","addRM":"Add RM","noWorker":"No Worker","noJobList":"No Job List","redirectPage":"Redirect Page","list":"รายการ","areYouSureDelete":"Are you sure to cancel this request?. Please enter a reason.","areYouSureRemove":"ต้องการลบรายการที่เลือกใช่หรือไม่?","areYouSureConfirm":"Are you sure to confirm this request?","areYouSureReject":"Are you sure to reject this request?. Please enter a reason","manage":"Manage","default":"Default","favorite":"Favorite","seeMore":"See More","noAssetCode":"No Asset Code","clearSearch":"Clear","users":"Users","total":"ยอดรวม","selectUser":"Select User","firstName":"First Name","lastName":"Last Name","empId":"Emp Id","position":"Level","controlPosition":"Control","requestApprove":"Request Approve","setOkr":"Set Okr","noApproval":"No Approval","noAdmin":"No Admin","canCreateOkr":"Create","canEditOkr":"Edit","canDeleteOkr":"Delete","canChangeProgressOkr":"Change Progress","permissionOkr":"Permission","updateImage":"Update Logo Banner","adminMenuSetting":"Admin Menu Setting","uploadLogo":"Upload Logo","uploadBanner":"Upload Banner","checkConnectO365":"Check Connect O365","checkConnectAX":"Check Connect AX","male":"ชาย","female":"หญิง","other":"อื่นๆ","placeholderText":"ระบุข้อความยืนยัน..","confirmDelete":"คุณต้องการจะลบรายการนี้หรือไม่","firstTextDelete":"ระบุข้อความ ","lastTextDelete":"เพื่อลบข้อมูล","checkText":"ข้อความยืนยันไม่ถูกต้อง","confirmSave":"คุณต้องการบันทึกหรือไม่","confirmAll":"คุณต้องการบันทึกการเปลี่ยนแปลงทั้งหมดหรือไม่","reportBug":"แจ้งข้อผิดพลาดของระบบ","nameTh":"ชื่อ (ภาษาไทย)","nameEn":"ชื่อ (ภาษาอังกฤษ)","announce":"ประกาศ","announceBodyTh":"รายละเอียดการประกาศ (ภาษาไทย)","announceBodyEn":"รายละเอียดการประกาศ (ภาษาอังกฤษ)","announceType":"ประเภทของการประกาศ","lastLogin":"จำนวนผู้ใช้งานล่าสุด (24 ชม.) : ","selectItem":"เลือก","description":"รายละเอียด","cost":"ค่าใช้จ่าย","noData":"ไม่มีข้อมูล","userGroupNotFound":"ไม่มีข้อมูล","active":"เปิดใช้งาน","YieldToday":"ไฟฟ้าที่ผลิตได้วันนี้","YieldMonth":"ไฟฟ้าที่ผลิตได้เดือนนี้","TotalYield":"ไฟฟ้าที่ผลิตได้ทั้งหมด","RevenueToday":"ค่าไฟฟ้าที่ผลิตได้วันนี้","TotalRevenue":"ค่าไฟฟ้าที่ผลิตได้ทั้งหมด","capacity":"ความจุ","activePower":"พลังที่ใช้งานอยู่","id":"รหัส","sn":"รหัสทรัพย์สิน","nameDevice":"ชื่ออุปกรณ์","listDevice":"รายการอุปกรณ์","stationCode":"รหัสสถานี","typeId":"ประเภทรหัส","voltage":"แรงดันไฟฟ้า","frequency":"ความถี่","current":"ปัจจุบัน","ampere":"กระแสไฟ","companySetting":"ตั้งค่าเกี่ยวกับบริษัท","changeImage":"แก้ไขรูปภาพ","stationNotFound":"ไม่พบสถานี","home":"หน้าหลัก","dashboard":"ภาพรวม","map":"แผนที่","refresSetting":"รีเฟรชการตั้งค่า","adminSetting":"ตั้งค่าผู้ดูแลระบบ","site":"สถานที่","station":"สถานี","userGroup":"กลุ่มผู้ใช้","user":"ผู้ใช้","device":"อุปกรณ์","setTimeToRefresh":"ตั้งเวลาในการรีเฟรช","min":"นาที","company":"บริษัท","report":"รายงาน","pleaseSelectTheInformationYouWant":"กรุณาเลือกข้อมูลที่ต้องการ","downLoad":"ดาวน์โหลด Excel","fromDate":"ตั้งแต่วันที่","toDate":"ถึงวันที่","allDevice":"อุปกรณ์ทั้งหมด","status":"สถานะ","overView":"ถาพรวม","logoCompany":"โลโก้บริษัท","imageDiagram":"ภาพแผงวงจร","imageSite":"ภาพสถานที่","administrator":"สิทธิ์ผู้ดูแลระบบ","running":"กำลังทำงาน","softwareVersion":"เวอร์ชั่นซอฟต์แวร์","model":"โมเดล","deviceType":"ชนิดของอุปกรณ์","loading":"กำลังโหลด...","noImage":"ไม่มีรูปภาพ","warning":"คำเตือน: การสาธิตเว็บไซต์นี้จะหมดอายุในวันที่ 1/5/2567 โปรดติดต่อผู้ขาย"}}

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

module.exports = {"login":{"signinNormal":"ลงชื่อเข้าใช้","email":"อีเมล","Password":"รหัสผ่าน","login":"เข้าสู่ระบบ","ForgotPassword":"ลืมรหัสผ่าน?","somethingWrong":"Something Went Wrong, Please Try Again.","yourData":"Confirm Your Information.","validateError":"Validate error, Please fill in all require data.","validateCommentError":"Please enter a comment","attachError":"Upload error, Please choose file","fileError":"Upload error, Please choose file type pdf, jpg, png","squareInch":"SQUARE INCH","version":"Version","profile":"profile","optAgain":"ขอ OTP อีกครั้ง","logout":"Log out","send":"ส่ง","npiSystem":"NPI System","pageNotFound":"Page not found, Please re-check your url again.","unauthen":"Unauthorized, Please contact administrator for request access.","success":"Success","fail":"Fail","itemCode":"Item Code","itemStatus":"Item Status","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","right":"Right","left":"Left","edit":"Edit","reject":"Reject","search":"Search","lastUpdateBy":"Last Update by","create":"Create","view":"View","update":"Update","value":"Value","createFail":"Create Fail","updateFail":"Update Fail","upload":"Upload","comment":"Comment","close":"Close","confirm":"Confirm","save":"Save","chooseOptions":"Choose an option","add":"Add","submit":"Submit","transfer":"Transfer","scan":"Scan","receive":"Receive","deleteBy":"Delete By","print":"Print","duplicate":"Duplicate","enter":"Enter","scanId":"Scan ID for Booking","waitingForManager":"Waiting for Manager...","breakSection":"Break, Please Scan ID for Start","clearPD":"Clear PD","clearWorker":"Clear Worker","pdListAlert":"PD List Warning","workerListAlert":"Worker List Not Exist on System","delete":"Delete","pleaseContactAdminAx":"Please Contact AX Admin","pleaseCheckData":"Please Check Data","pleaseSelect":"Please Select Item","select":"Select","addRM":"Add RM","noWorker":"No Worker","noJobList":"No Job List","redirectPage":"Redirect Page","list":"List","areYouSureDelete":"Are you sure to cancel this request?. Please enter a reason.","areYouSureRemove":"Are you sure to remove this item?","areYouSureConfirm":"Are you sure to confirm this request?","areYouSureReject":"Are you sure to reject this request?. Please enter a reason","manage":"Manage","default":"Default","favorite":"Favorite","seeMore":"See More","noAssetCode":"No Asset Code","clearSearch":"Clear","users":"Users","total":"Total","selectUser":"Select User","firstName":"First Name","lastName":"Last Name","empId":"Emp Id","position":"Level","controlPosition":"Change","requestApprove":"Request Approve","setOkr":"Set Okr","noApproval":"No Approval","noAdmin":"No Admin","canCreateOkr":"Create","canEditOkr":"Edit","canDeleteOkr":"Delete","canChangeProgressOkr":"Change Progress","permissionOkr":"Permission","updateImage":"Update Logo Banner","adminMenuSetting":"Admin Menu Setting","uploadLogo":"Upload Logo","uploadBanner":"Upload Banner","checkConnectO365":"Check Connect O365","checkConnectAX":"Check Connect AX","male":"Male","female":"Female","other":"Other","placeholderText":"Confirm text..","confirmDelete":"Are you sure you want to delete?","firstTextDelete":"Input text ","lastTextDelete":"for delete!","checkText":"Confirm text not match!","confirmSave":"Do you want to save it?","confirmAll":"Do you want to save all changes?","reportBug":"Bug hunter form","nameTh":"Name TH","nameEn":"Name EN","announce":"Announcement","announceBodyTh":"Announcement TH","announceBodyEn":"Announcement EN","announceType":"Announce Type","lastLogin":"No. recent logins (24h) : ","selectItem":"Select ","description":"Description","cost":"Cost"}}

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

module.exports = {"menu":{"site":"สถานที่","userGroup":"กลุ่มผู้ใช้","user":"ผู้ใช้งาน"}}

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

module.exports = {"settings":{"nameEn":"ชื่อ (ภาษาอังกฤษ)","nameTh":"ชื่อ (ภาษาไทย)","address":"ที่อยู่","email":"อีเมล","groupName":"ชื่อ","groupCode":"รหัส","groupDescription":"รายละเอียด","stationIds":"รหัสสถานี","firstName":"ชื่อ","lastName":"นามสกุล","age":"อายุ","password":"รหัสผ่าน","userGroupId":"กลุ่มผู้ใช้งาน","companyId":"บริษัท","siteId":"สถานที่","station":"สถานี","add":"เพิ่ม","stationName":"ชื่อสถานี","siteName":"ชื่อสถานที่","status":"สถานะ"}}

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

module.exports = {"report":{"stations":"สถานี","headers":"หัวข้อ"}}

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

module.exports = {"purchase":{"sellerRegister":"เอกสารขอขึ้นทะเบียนผู้ขาย","request":"ผู้ขอ","agency":"หน่วยงานต้นสังกัด","purchaseName":"ผู้ขอซื้อ","dateRequested":"วันที่ขอ","purpose":"วัตถุประสงค์","project":"โปรเจค","vendorAccount":"บัญชีผู้ขาย","costcentor":"ทีม/แผนก","site":"ที่ตั้ง","companyAddress":"ที่อยู่บริษัท","currency":"สกุลเงิน","description":"รายละเอียด","branch":"สาขา","agencyCode":"รหัสหน่วยงานต้นสังกัด","nameTh":"ชื่อผู้ขาย (ไทย)","nameEn":"ชื่อผู้ขาย (อังกฤษ)","contact":"ผู้ติดต่อ","email":"อีเมล","tax":"เลขที่ผู้เสียภาษี (บุคคลธรรมดาระบุเลขที่มีบัตรประชาชน)","purchasePart":"ส่วนงานจัดซื้อ","sellerGroupItem":"กลุ่มสินค้าที่ขาย (อ้าง Vendor หรือ Material Group)","sellerHeader":"ข้อมูลผู้ขาย","document":"เอกสาร","poId":"เลขที่ขอซื้อ"},"npi":{"date":"วันที่","productType":"ประเภทสินค้า","productNumber":"หมายเลขผลิตภัณฑ์","productName":"ชื่อผลิตภัณฑ์","searchName":"ชื่อที่ใช้ค้นหา","itemModelGroup":"กลุ่มโมเดลรายการ","itemGroup":"กลุ่มรายการ","itemSaleStax":"รายการภาษีการขาย","itemSalesPurchase":"รายการซื้อขาย","storageDimansionGroup":"กลุ่มการจัดเก็บ","trackingDimansionGroup":"ติดตามกลุ่ม","buyerGroup":"กลุ่มผู้ซื้อ","purchaseUnit":"หน่วยซื้อ","salesUnit":"หน่วยขาย","bomUnit":"Bom Unit","vender":"ผู้ขาย","venderItemNumber":"หมายเลขรายการผู้ขาย","inventoryUnit":"หน่วยสินค้าคลัง","section":"หัวข้อ"},"core":{"requesterCutPropCode":"รหัสผู้ขอตัดทรัพย์สิน","requesterCode":"รหัสผู้ขอ","title":"หัวข้อ","value":"มูลค่า","project":"โปรเจ็ค","approvalHierarchy":"ลำดับขั้นการอนุมัติ (เรียงจากบนลงล่าง)","member":"สมาชิก","destinationRecipient":"ผู้รับปลายทาง (ระบบจะส่งอีเมลหาทุกคน)","allAprove":"ใช่ (กรณีต้องการให้ผู้รับปลายทางทุกคนต้องกดรับทราบจึงจะจบเอกสาร)","conditionsForRecipients":"เงื่อนไขผู้รับปลายทาง","oneApprove":"ไม่ (กรณีต้องการให้คนใดคนหนึ่งในรายชื่อผู้รับปลายทางกดรับทราบจึงจะจบเอกสาร","company":"บริษัท","recipient":"ผู้รับ","sender":"ผู้ส่ง","removeDate":"วันที่นำของออก","propertytype":"ประเภททรัพย์สิน","quantity":"จำนวน","reason":"เหตุผล","serialNumber":"หมายเลขซีเรียล"},"generalAdmin":{"date":"วันที่","agencyCode":"รหัสหน่วยงานต้นสังกัด","agency":"หน่วยงานต้นสังกัด","team":"หน่วยงานต้นสังกัด","departmentTranferAssest":"แผนกที่ต้องการโอนทรัพย์สิน","departmentReceivesProp":"แผนกที่รับทรัพย์สิน","specifyItem":"ระบุรายการที่จะโอนไปยังบุคคลที่รับโอน","tranferApprove":"ข้าพเจ้าเป็นผู้โอนตกลงโอนทรัพย์สินดังต่อไปนี้และผู้รับโอนตกลงรับโอนสิ่งของดังกล่าว จึงเรียนมาเพื่อโปรดดำเนินการโอน","Requisitioner":"ผู้ขอเบิก","forWork":"สำหรับใช้ในการปฎิบัติงาน(เบิกใหม่)","forReplace":"สำหรับทดแทนของเดิมที่ชำรุด","description":"รายละเอียด","requesterCutPropCode":"รหัสผู้ขอตัดทรัพย์สิน","add":"เพิ่ม","purpose":"วัตถุประสงค์การใช้งาน","requesterCode":"รหัสผู้ขอ","propertyCode":"รหัสทรัพย์สิน","employeeCode":"รหัสพนักงาน","fullName":"ชื่อ - นามสกุล","sequence":"ลำดับ","assetCode":"รหัสทรัพย์สิน","assetName":"ชื่อทรัพย์สิน","assetDes":"รายละเอียดทรัพย์สิน","assetDesTH":"รายละเอียดทรัพย์สิน (ภาษาไทย)","assetDesEN":"รายละเอียดทรัพย์สิน (ภาษาอังกฤษ)","currentPrice":"ราคาปัจจุบัน","pricePerPeice":"ราคาต่อชิ้น","assetPrice":"ราคา/หน่วย","reqQty":"จำนวน","totalInStock":"จำนวนในคลัง","totalUsed":"จำนวนที่ใช้ไป","total":"รวม","purchaseDate":"วันที่ซื้อ","select":"เลือก","clickMeForSelectAsset":"คลิกที่นี่! เพื่อเลือกทรัพย์สิน","selectBeforSubmit":"เลือกอย่างน้อย 1 รายการก่อนกดบันทึก","assetNo":"เลขที่ทรัพย์สิน","detail":"ข้อมูลย่อย","spec":"ข้อมูลจำเพาะ","discountPercent":"ส่วนลดเปอร์เซ็นต์","totalBeforeDiscount":"ยอดรวมก่อนลดราคา","discountNumber":"ราคาส่วนลด","instock":"ในคลัง","action":"การดำเนินการ"},"finance":{"partyType":"ประเภทลูกค้า","startDate":"วันที่เริ่ม","requester":"ผู้ขอ","agencyCode":"รหัสหน่วยงานต้นสังกัด","agency":"หน่วยงานต้นสังกัด","customerStatus":"สถานะลูกค้า","customerCode":"รหัสลูกค้า","Pleaseenter":"ระบุ...","firstName":"ชื่อ","lastName":"นามสกุล","taxpayerIdentificationNumber":"เลขประจำตัวผู้เสียภาษี","company":"ชื่อบริษัท/หน่วยงาน","customerGroup":"กลุ่มลูกค้า","paymentTerm":"เงื่อนไขการชำระเงิน","deliveryTerm":"ระยะเวลาการจัดส่ง","deliveryMode":"โหมดการจัดส่ง","country":"ประเทศ","details":"รายละเอียด","customerAddress":"ที่อยู่ของลูกค้า","condition":"เงื่อนไขหรือระเบียบการวางบิลและรับเช็ค (เอกสารจากลูกค้า)","billingPlace":"สถานที่วางบิล","contactName":"ชื่อผู้ติดต่อ","contactFullName":"ชื่อ-นามสกุล ผู้ติดต่อ","telephoneNumber":"เบอร์โทรศัพท์","PlacReceiveChecks":"สถานที่รับเช็ค","BillingDocuments":"เอกสารที่ประกอบการวางบิลมีอะไรบ้าง","CheckReceiptDocument":"เอกสารที่ประกอบการรับเช็คมีอะไรบ้าง","payType":"ประเภทการจ่ายเงิน","creditLine":"วงเงินเครดิต","creditPeriod":"ระยะเวลาเครดิต","mandatory":"บังคับจำกัดวงเงิน","ApprovalReason":"เหตุผลการขออนุมัติ","documentsTypes":"เอกสารขอเบิกเงินประเภท","projectName":"ชื่อโครงการ/ชื่องาน","projectDetail":"รายละเอียดของโครงการ","workValue":"มูลค่างาน","objectivesReception":"วัตถุประสงค์ การเลี้ยงรับรอง","nameSurname":"ชื่อ-นามสกุล","position":"ตำแหน่ง","note":"หมายเหตุ","ceremonyOn":"เลี้ยงรับรองเมื่อวันที่","Amount(Baht)":"จำนวนเงิน (บาท)","receptionResults":"ผลการเลี้ยงรับรอง","acceptDocument":"ข้าพเจ้าขอรับรองว่าเป็นความจริงทุกประการ"},"all":{"upload":"อัปโหลด","workflowstatus":"ขั้นตอนการอนุมัติงาน","save":"บันทึก","attachDocuments":"แนบเอกสาร","add":"เพิ่ม","waitLoading":"รอสักครู่ กำลังโหลดข้อมูล"},"it":{"requestUser":"ขอสิทธิใช้การงานคอมพิวเตอร์","requester":"ผู้ขอ","agencycode":"รหัสหน่วยงานต้นสังกัด","agency":"หน่วยงานต้นสังกัด","description":"เหตุผลการขอ","lsicense":"สิทธิการใช้งาน","adcode":"รหัส AD","adname":"ชื่อ AD","expenses":"ค่าใช้จ่าย","sum":"รวม","attachdocuments":"แนบเอกสาร","upload":"อัปโหลด","save":"บันทึก","hardware":"เอกสารใบเบิกอุปกรณ์ Hardware","requesto":"ขอให้","deviceID":"รหัสอุปกรณ์","name":"ชื่อ","add":"เพิ่ม","requesrightsto":"ขอสิทธิให้","purposeofuse":"วัตถุประสงค์การใช้งาน","forwork":"สำหรับใช้ในการปฎิบัติงาน(เบิกใหม่)","forreplacing":"สำหรับทดแทนของเดิมที่ชำรุด","type":"ประเภท","preview":"ตัวอย่าง","download":"ดาวน์โหลด","createby":"สร้างโดย","test":"ทดสอบ","close":"ปิด"},"fileUpload":{"fileName":"ชื่อไฟล์","fileType":"ประเภทไฟล์","fileSize":"ขนาดไฟล์"},"hr":{"timeStart":"เวลาที่เริ่ม","timeEnd":"เวลาที่สิ้นสุด"},"comment":{"empId":"รหัสพนักงาน","commentBy":"คอมเมนต์โดย","msg":"ข้อความ","createDate":"วันที่สร้าง","selectViewer":"เลือกผู้มีสิทธิ์เกี่ยวกับเอกสาร","addToComment":"เพิ่มในคอมเมนต์","deleteToComment":"ลบออกจากคอมเมนต์"},"task":{"task":"งาน","title":"รายละเอียด","documentNumber":"เลขที่เอกสาร","doc":"รายละเอียดเอกสาร","additional":"ดูรายละเอียดเอกสารเพิ่มเติม"},"ncReport":{"ncReport":"รายงานการพบผลิตภัณฑ์ ที่ไม่เป็นไปตามข้อกำหนด","pdRef":"PD (CIG เลขที่) ","non":"รายงานการพบผลิตภัณฑ์ ที่ไม่เป็นไปตามกำหนด","status":"ประเภทและสถานะของผลิตภัณฑ์ที่ไม่เป็นไปตามข้อกำหนด","unit":"หน่วยงานที่พบข้อบกพร่อง","drwNo":"เลขที่ DRW.","coilNo":"เลขที่คอยล์","coilSize":"ขนาดคอยล์","nonCompliance":"ลักษณะความไม่เป็นไปตาม","specifications":"ข้อกำหนดของผลิตภัณฑ์","agency":"ผลิตภัณฑ์ที่ไม่เป็นไปตามข้อกำหนด เกิดขึ้นที่ หน่วยงาน","found":"พบที่หน่วยงาน","cause":"เป็นสาเหตุที่เกิดจาก","operator":"ผู้รับดำเนินการ","operation":"การดำเนินการ","release":"อนุโลมให้ยอมรับ","reasonConditions":"เงื่อนไข / เหตุผล ในการอนุโลม","approval":"ผู้ขออนุมัติอนุโลม","partiesAgree":"ฝ่ายร่วมอนุโลม","sales":"ฝ่ายขาย","planning":"ฝ่ายวางแผน","production":"ฝ่ายผลิต","npl":"แผนก NPL","qa":"รับทราบโดยฝ่าย QA","customer":"ลูกค้ายอมรับผลิตภัณฑ์ที่ไม่เป็นไปตามข้อกำหนดตามหลักฐาน หนังสือยินยอม","fQa":"F-QA-02-21 เลขที่","use":"ลงวันที่ผลจากการนำไปใช้งาน / ส่งมอบ","verifier":"ผู้ทวนสอบ","date":"วันที่","rework":"ทำการแก้ไข","way":"วิธีการ","qaDepartment":"ฝ่าย QA","action":"การดำเนินการ","operating":"หน่วยงานที่ดำเนินการ","proceed":"วิธีดำเนินการ","wasteGenerated":"ของเสียที่เกิดขึ้น","aluminum":"อลูมิเนียม / กิโลกรัม","copper":"ทองแดง / กิโลกรัม","plate":"เพลท / กิโลกรัม","dateCompleted":"วันที่แล้วเสร็จสิ้น","modifier":"ผู้ดำเนินการแก้ไข","verification":"ผลการทวนสอบผลิตภัณฑ์ที่แก้ไขแล้ว","inspector":"ฝ่ายผลิตผู้ตรวจปล่อย","unitQa":"Q.C. หน่วย","reject":"ไม่ยอมรับ","approve":"อนุมัติเลือกวิธีดำเนินการ","manager":"ผจก.ฝ่าย/แผนกผลิต","managerQa":"ผจก.ฝ่าย/แผนกQA","mo":"ออกใบสั่งผลิต (MO.) ใหม่เพื่อผลิตทดแทน","quantity":"จำนวน (ชิ้น / ต่อ)","pd":"PD","fin":"1P-FIN จำนวน (ชิ้น / ต่อ)","cu":"1P-CU จำนวน (ชิ้น / ต่อ)","pla":"1P-PLA จำนวน (ชิ้น / ต่อ)","hd":"1P-HD-CU จำนวน (ชิ้น / ต่อ)","ass":"1P-ASSCoil จำนวน (ชิ้น / ต่อ)","bra":"1P-BRA จำนวน (ชิ้น / ต่อ)","pack":"1P-PACK จำนวน (ชิ้น / ต่อ)","replacement":"หน่วยงานที่ทำทดแทน","processingDate":"วันที่ดำเนินการ","completionDate":"วันที่แล้วเสร็จจริง","personAppov":"ผู้อนุมัติให้ดำเนินการ (ผจก.ฝ่าย/แผนก ผลิต)","branch":"สาขา","orderPd":"เลขที่ใบสั่งผลิต PD","reference":"เลขที่อ้างอิง PD","productionOrder":"จำนวนสั่งผลิต","quantityPd":"จำนวนที่ต้องผลิตทดแทน","reasonPd":"สาเหตุที่ต้องทดแทน","NcrPdNumber":"เลขที่ใบ NCR","inch":"ลบ.นิ้ว","agenciesPD":"หน่วยงานที่ต้องเปิดใบสั่งผลิตทดแทน","substitutePd":"ผู้ร้องขอทดแทน","inspectorPd":"ผู้ตรวจสอบ","because":"โปรดระบุเหตุผล...","dateNCR":"วันที่ออก NCR","ncPdNumber":"เลขที่ NC.PD. ","ncrNumber":"เลขที่ NCR","ncName":"ชื่อผู้รายงาน","dateReport":"วันที่รายงาน","shiftTimeReport":"เวลาพบ","productOrderNumber":"เลขที่ใบสั่งผลิต (MO.)","manufactureNumber":"จำนวนสั่งผลิต","problemNumber":"จำนวนที่พบปัญหา","priceInprocess":"ชิ้นส่วน/ส่วนประกอบ ระหว่างผลิต","priceReadymade":"ชิ้นส่วน/ส่วนประกอบ สำเร็จรูป","productInprocess":"ผลิตภัณฑ์ (แผงคอยล์) ระหว่างผลิต","productReadymade":"ผลิตภัณฑ์ (แผงคอยล์) สำเร็จรูป","meterial":"วัตถุดิบ","method":"วิธีการ","machine":"เครื่องจักร","person":"คน"},"im":{"expireDate":"วันที่หมดอายุ (mm/dd/yyyy)","inspectionWeight":"ม้วน/นน.สุทธิ","palleteTotal":"น้ำหนักรวม (พาเลท)(Kg.)","netWeight":"น้ำหนักสุทธิ (Kg.)","package":"Package No./Coil No.","Type":"ชนิด วัตถุดิบ/อุปกรณ์","Result":"ผลการตรวจสอบ ข้อมูลการส่งมอบวัตถุดิบ/อุปกรณ์ เปรียบเทียบกับการสั่งซื้อจาก PO.","qaResult":"บันทึกผลการตรวจสอบรับเข้า","receive":"บันทึกรับเข้าสโตร์","defect":"จำนวนจุดเสีย","location":"สถานที่จัดเก็บ","vendInvoice":"เลขที่ Invoice","receiptDate":"วันที่รับเข้า","receiptNumber":"เลขที่รับเข้า","searchPO":"ค้นหา PO","itemId":"รหัสสินค้า","itemType":"ประเภทรายการ","itemName":"ชื่อสินค้า","vendor":"ชื่อผู้ขาย","spacialReceivePerson":"ผู้อนุมัติให้รับเข้ากรณีพิเศษ"}}

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export URL_INCOMING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOKEN; });
/* unused harmony export EXPIRES_ON */
/* unused harmony export EXPIRES_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_ID; });
/* unused harmony export EMP_ID */
/* unused harmony export FULL_NAME */
/* unused harmony export ROLE */
/* unused harmony export EMAIL */
/* unused harmony export O365_TOKEN */
/* unused harmony export USER_IMAGE */
/* unused harmony export DEVICE_ADMIN */
/* unused harmony export IS_ADMIN */
/* unused harmony export STATION_DISPLAY */
/* unused harmony export PICKING_DISPLAY */
/* unused harmony export REPORT_AS_FINISH_DISPLAY */
/* unused harmony export JOB_CARD_DISPLAY */
/* unused harmony export WARE_HOUSE_DISPLAY */
/* unused harmony export STATION_NAME_DISPLAY */
/* unused harmony export DISPLAY_SETTINGS */
/* unused harmony export DEVICE_ID */
/* unused harmony export DEVICE_NAME */
/* unused harmony export DISPLAY_NAME */
/* unused harmony export TABLE_NAME_ACTIVE */
/* unused harmony export FULL_NAME_TH */
/* unused harmony export FULL_NAME_EN */
/* unused harmony export DELEGATE_TO_ME */
/* unused harmony export DATA_AREA */
/* unused harmony export TEAM_ID */
/* unused harmony export URL_DOCUMENT */
/* unused harmony export URL_AUTH_TICATION_EMP_MODE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLIENT_ID; });
/* unused harmony export URL_SET_O365_TOKEN_COOKIE */
/* unused harmony export URL_SET_USER_IMAGE_COOKIE */
/* unused harmony export URL_SET_DATA_AREA */
/* unused harmony export URL_AUTHEN_TICATION_DEVICE */
/* unused harmony export URL_DEVICE_ADMIN */
/* unused harmony export URL_IS_ADMIN */
/* unused harmony export getCookie */
/* harmony export (immutable) */ __webpack_exports__["h"] = getAllCookies;
/* harmony export (immutable) */ __webpack_exports__["k"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["d"] = authentication;
/* unused harmony export setCookie */
/* harmony export (immutable) */ __webpack_exports__["g"] = clearToken;
/* harmony export (immutable) */ __webpack_exports__["o"] = setUrlIncoming;
/* harmony export (immutable) */ __webpack_exports__["l"] = getUrlIncoming;
/* harmony export (immutable) */ __webpack_exports__["f"] = authenticationEmpMode;
/* harmony export (immutable) */ __webpack_exports__["n"] = setO365TokenCookie;
/* harmony export (immutable) */ __webpack_exports__["p"] = setUserImageCookie;
/* harmony export (immutable) */ __webpack_exports__["m"] = setDataArea;
/* harmony export (immutable) */ __webpack_exports__["e"] = authenticationDevice;
/* harmony export (immutable) */ __webpack_exports__["i"] = getDeviceAdmin;
/* harmony export (immutable) */ __webpack_exports__["j"] = getIsAdmin;
/* unused harmony export getUserImageCookie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var URL_INCOMING = 'url_incoming';
var TOKEN = 'token';
var EXPIRES_ON = 'expires_on';
var EXPIRES_DATE = 'expires_date';
var USER_ID = 'user_id';
var EMP_ID = 'emp_id';
var FULL_NAME = 'fullname';
var ROLE = 'role';
var EMAIL = 'email';
var O365_TOKEN = 'o365_token';
var USER_IMAGE = 'user_image';
var DEVICE_ADMIN = 'DEVICE_ADMIN';
var IS_ADMIN = 'is_admin';
var STATION_DISPLAY = 'station_display';
var PICKING_DISPLAY = 'picking_display';
var REPORT_AS_FINISH_DISPLAY = 'report_as_finish_display';
var JOB_CARD_DISPLAY = 'job_card_display';
var WARE_HOUSE_DISPLAY = 'ware_house_display';
var STATION_NAME_DISPLAY = 'station_name_display';
var DISPLAY_SETTINGS = 'display_settings';
var DEVICE_ID = 'deviceId';
var DEVICE_NAME = 'deviceName';

var DISPLAY_NAME = 'display_name';
var TABLE_NAME_ACTIVE = 'table_name_active';
var FULL_NAME_TH = 'fullnameTh';
var FULL_NAME_EN = 'fullnameEn';
var DELEGATE_TO_ME = 'delegateToMe';
var DATA_AREA = 'area';
var TEAM_ID = 'teamId';
var URL_DOCUMENT = 'url_document';
var URL_AUTH_TICATION_EMP_MODE = 'url_auth_tication_emp_mode';
var CLIENT_ID = 'client_id';
var URL_SET_O365_TOKEN_COOKIE = 'url_set_o365_token_cookie';
var URL_SET_USER_IMAGE_COOKIE = 'url_set_user_image_cookie';
var URL_SET_DATA_AREA = 'url_set_data_area';
var URL_AUTHEN_TICATION_DEVICE = 'url_authen_tication_device';
var URL_DEVICE_ADMIN = 'url_device_admin';
var URL_IS_ADMIN = 'url_is_admin';

function getCookie(key) {
    try {
        var value = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(key);
        var setValue = '';

        if (value && typeof value === 'string') {
            setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.decode(value);
        }
        return setValue;
    } catch (error) {
        return null;
    }
}
function getAllCookies() {
    var _ref;

    return _ref = {}, _defineProperty(_ref, TOKEN, getCookie(TOKEN)), _defineProperty(_ref, EXPIRES_ON, getCookie(EXPIRES_ON)), _defineProperty(_ref, EXPIRES_DATE, getCookie(EXPIRES_DATE)), _defineProperty(_ref, USER_ID, getCookie(USER_ID)), _defineProperty(_ref, DEVICE_ADMIN, getCookie(DEVICE_ADMIN)), _defineProperty(_ref, IS_ADMIN, getCookie(IS_ADMIN)), _defineProperty(_ref, DELEGATE_TO_ME, getCookie(DELEGATE_TO_ME)), _ref;
}
function getToken() {
    return getCookie(TOKEN);
}

function authentication(dataAuth) {
    var _dataAuth$user = dataAuth.user,
        email = _dataAuth$user.email,
        fullName = _dataAuth$user.fullName,
        id = _dataAuth$user.id,
        deviceAdmin = _dataAuth$user.deviceAdmin,
        isAdmin = _dataAuth$user.isAdmin,
        imageUrl = _dataAuth$user.imageUrl,
        firstNameEN = _dataAuth$user.firstNameEN,
        firstNameTH = _dataAuth$user.firstNameTH,
        lastNameEN = _dataAuth$user.lastNameEN,
        lastNameTH = _dataAuth$user.lastNameTH,
        username = _dataAuth$user.username,
        delegateToMeIds = _dataAuth$user.delegateToMeIds,
        teamId = _dataAuth$user.teamId,
        dataArea = dataAuth.dataArea,
        token = dataAuth.token,
        expiresDate = dataAuth.expiresDate,
        expiresOn = dataAuth.expiresOn;

    clearToken();
    var fullnameEn = firstNameEN + ' ' + lastNameEN;
    var fullnameTh = firstNameTH + ' ' + lastNameTH;
    setCookie(FULL_NAME, fullName);
    setCookie(FULL_NAME_TH, btoa(unescape(encodeURIComponent(fullnameTh))));
    setCookie(FULL_NAME_EN, btoa(unescape(encodeURIComponent(fullnameEn))));
    // setCookie(FULL_NAME_EN, fullnameEn)
    setCookie(EMAIL, email);
    setCookie(USER_ID, id);
    setCookie(DATA_AREA, dataArea);

    setCookie(TOKEN, token);
    setCookie(EXPIRES_DATE, expiresDate);
    setCookie(EXPIRES_ON, expiresOn);
    setCookie(DEVICE_ADMIN, deviceAdmin);
    setCookie(IS_ADMIN, isAdmin);
    setCookie(DISPLAY_NAME, username);
    setCookie(USER_IMAGE, imageUrl);
    setCookie(TEAM_ID, teamId);
    setCookie(DELEGATE_TO_ME, JSON.stringify(delegateToMeIds));
}

function setCookie(key, value, expires) {
    var valueToString = String(value);
    var setValue = '';
    if (typeof valueToString === 'string') {
        setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.encode(valueToString);
    }
    if (expires && typeof expires === 'number' && expires > 0) {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue, { expires: expires });
    } else {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue);
    }
}

function removeCookie(key) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.remove(key);
}

function clearToken() {
    removeCookie(TOKEN);
    removeCookie(DATA_AREA);
    removeCookie(EXPIRES_DATE);
    removeCookie(USER_ID);
    removeCookie(FULL_NAME);
    removeCookie(FULL_NAME_TH);
    removeCookie(FULL_NAME_EN);
    removeCookie(EMAIL);
    removeCookie(IS_ADMIN);
    removeCookie(DEVICE_ADMIN);
    removeCookie(URL_INCOMING);
    removeCookie(DEVICE_ID);
    removeCookie(DEVICE_ADMIN);
    removeCookie(DEVICE_NAME);
    removeCookie(TEAM_ID);
    removeCookie(DELEGATE_TO_ME);
}

function setUrlIncoming(data) {
    setCookie(URL_INCOMING, data);
}

function getUrlIncoming() {
    return getCookie(URL_INCOMING);
}

function authenticationEmpMode() {
    return getCookie(URL_AUTH_TICATION_EMP_MODE);
}
function setO365TokenCookie() {
    return getCookie(URL_SET_O365_TOKEN_COOKIE);
}
function setUserImageCookie() {
    return getCookie(URL_SET_USER_IMAGE_COOKIE);
}
function setDataArea() {
    return getCookie(URL_SET_DATA_AREA);
}
function authenticationDevice() {
    return getCookie(URL_AUTHEN_TICATION_DEVICE);
}
function getDeviceAdmin() {
    return getCookie(URL_DEVICE_ADMIN);
}
function getIsAdmin() {
    return getCookie(URL_IS_ADMIN);
}
function getUserImageCookie() {
    return getCookie(USER_IMAGE);
}

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getErrorList;
/* unused harmony export getCallAPI */
/* harmony export (immutable) */ __webpack_exports__["b"] = getLoading;
function getErrorList(state) {
    return state.errorList;
}

function getCallAPI(state) {
    return state.callAPI;
}

function getLoading(state) {
    return state.isLoading;
}

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/lib/api.js
var api = __webpack_require__(43);

// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(28);

// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var defaultDateFormat = 'MMMM DD, YYYY';
var defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm';
// CONCATENATED MODULE: ./src/lib/shareFunctions.js
var mapOptions = function mapOptions(data) {
    var options = [];
    options = data.map(function (d) {
        return {
            value: d.id,
            text: d.name
        };
    });
    return options;
};
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return api["b" /* CORE_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return api["c" /* REDIRECT_O365_URI */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return api["a" /* API_MAP_KEY */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return auth["b" /* TOKEN */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return auth["c" /* USER_ID */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return auth["a" /* CLIENT_ID */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return auth["h" /* getAllCookies */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["k" /* getToken */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["d" /* authentication */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return auth["g" /* clearToken */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["o" /* setUrlIncoming */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return auth["l" /* getUrlIncoming */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["f" /* authenticationEmpMode */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["n" /* setO365TokenCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["p" /* setUserImageCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["m" /* setDataArea */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["e" /* authenticationDevice */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return auth["i" /* getDeviceAdmin */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return auth["j" /* getIsAdmin */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateTimeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return mapOptions; });





/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 501, 502, 503];

function getAction(type, action, state, res) {
	return new Promise(function (resolve, reject) {
		if (!res) return resolve({ type: type });
		if (resStatusError.includes(res.status)) {
			return reject({ statusCode: res.status, statusText: res.statusText, errorList: state.errorList });
		}

		if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
			if (type.payload) {
				var payload = type.payload(action, state, res);

				if (res && res.status === 204) {
					var body = {
						result: res.ok
					};
					return resolve({ type: type.type, payload: _extends({}, body) });
				}

				if (typeof payload.then === 'function') {
					//promise
					return payload.then(function (data) {
						return resolve({ type: type.type, payload: data });
					});
				} else {
					return resolve({ type: type.type, payload: payload });
				}
			}

			return resolve({ type: type.type });
		}

		res.json().then(function (payload) {
			return resolve({ type: type, payload: payload });
		});
	});
}

/* harmony default export */ var api = (function (_ref) {
	var getState = _ref.getState;
	return function (next) {
		return function (action) {
			if (_typeof(action[CALL_API]) !== 'object') return next(action);

			var _action$CALL_API = action[CALL_API],
			    endpoint = _action$CALL_API.endpoint,
			    _action$CALL_API$meth = _action$CALL_API.method,
			    method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
			    headers = _action$CALL_API.headers,
			    body = _action$CALL_API.body,
			    types = _action$CALL_API.types;

			var _types = _slicedToArray(types, 3),
			    request = _types[0],
			    success = _types[1],
			    failure = _types[2];

			var callBack = success.callBack;

			var state = getState();
			getAction(request, action, state).then(function (action) {
				return next(action);
			});

			if (callBack) {
				var url = { endpoint: endpoint, method: method };
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					return next(action);
				}).then(function () {
					return callBack();
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true, url: url });
				});
			} else {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					return next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true });
				});
			}
		};
	};
});
// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            next(action);
        };
    };
});
// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(28);

// CONCATENATED MODULE: ./src/middlewares/setToken.js
var setToken__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


// import { getCookie } from '../lib/auth';


/* harmony default export */ var setToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

            var token = null;
            var entryType = entry.types[0];

            if (entryType.startsWith('CORE')) {
                token = Object(auth["k" /* getToken */])();
            }

            if (!token) return next(action);
            //  return false
            entry.headers = setToken__extends({}, entry.headers);
            if (token) {
                entry.headers.Authorization = 'Bearer ' + token;
            }
            entry.headers['Access-Control-Allow-Origin'] = '*';
            entry.headers['Access-Control-Allow-Methods'] = '*';
            entry.headers['Access-Control-Allow-Headers'] = 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With';

            next(action);
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REDIRECT_O365_URI; });
/* unused harmony export AX_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_MAP_KEY; });

// // Localhost
// export const CORE_API_ENDPOINT = "http://localhost:2803"
// export const CORE_API_ENDPOINT = "https://solardashboarddev.cigblusolutions.com/api"
var CORE_API_ENDPOINT = "https://airportdev.cigblusolutions.com/api";
var REDIRECT_O365_URI = "http://localhost:8080/login";
var AX_URL = 'http://localhost:8080';
var API_MAP_KEY = 'AIzaSyAr0_xNXVux88WH3bK9cyke7J23SlXMRZ0';

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_auth__ = __webpack_require__(28);


var AuthManager = {
    setCookie: function setCookie(data) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_auth__["d" /* authentication */])(data);
    },
    setDeviceCookie: function setDeviceCookie(data) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_auth__["e" /* authenticationDevice */])(data);
    },
    setCookieEmp: function setCookieEmp(data) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_auth__["f" /* authenticationEmpMode */])(data);
    },
    setO365TokenCookie: function setO365TokenCookie(data) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_auth__["n" /* setO365TokenCookie */])(data);
    },
    setUserImageCookie: function setUserImageCookie(blob) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_auth__["p" /* setUserImageCookie */])(blob);
    },
    setDataArea: function setDataArea(area) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_auth__["m" /* setDataArea */])(area);
    },
    setUrlIncoming: function setUrlIncoming(url) {
        Object(__WEBPACK_IMPORTED_MODULE_0__lib_auth__["o" /* setUrlIncoming */])(url);
    },
    logout: function logout() {
        var callBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        Object(__WEBPACK_IMPORTED_MODULE_0__lib_auth__["g" /* clearToken */])();
        if (callBack) {
            return callBack;
        } else {
            return false;
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (AuthManager);

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return REQUEST_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return SET_LOADING; });
/* unused harmony export LOGOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_AUTH_VERIFY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_AUTH_VERIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_AUTH_VERIFY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_REQUEST_FORGOT_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTH_REQUEST_FORGOT_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_REQUEST_FORGOT_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return CORE_LOAD_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return CORE_LOAD_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return CORE_LOAD_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return CORE_LOAD_USER_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return CORE_LOAD_USER_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return CORE_LOAD_USER_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CORE_CREATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CORE_CREATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CORE_CREATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return CORE_UPDATE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return CORE_UPDATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return CORE_UPDATE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return CORE_LOAD_USER_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return CORE_LOAD_USER_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return CORE_LOAD_USER_GROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return CORE_LOAD_USER_GROUP_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return CORE_LOAD_USER_GROUP_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return CORE_LOAD_USER_GROUP_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CORE_CREATE_USER_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CORE_CREATE_USER_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CORE_CREATE_USER_GROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return CORE_UPDATE_USER_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return CORE_UPDATE_USER_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return CORE_UPDATE_USER_GROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CORE_DELETE_USER_GROUP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CORE_DELETE_USER_GROUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CORE_DELETE_USER_GROUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return CORE_LOAD_SITE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return CORE_LOAD_SITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return CORE_LOAD_SITE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return CORE_LOAD_SITE_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return CORE_LOAD_SITE_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return CORE_LOAD_SITE_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CORE_CREATE_SITE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CORE_CREATE_SITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CORE_CREATE_SITE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return CORE_UPDATE_SITE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return CORE_UPDATE_SITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return CORE_UPDATE_SITE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CORE_DELETE_SITE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CORE_DELETE_SITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CORE_DELETE_SITE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return CORE_LOAD_STATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return CORE_LOAD_STATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return CORE_LOAD_STATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return CORE_LOAD_STATION_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return CORE_LOAD_STATION_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return CORE_LOAD_STATION_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CORE_GET_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CORE_GET_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CORE_GET_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return CORE_GET_STATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return CORE_GET_STATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return CORE_GET_STATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return CORE_GET_EXCEL_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return CORE_GET_EXCEL_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return CORE_GET_EXCEL_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return CORE_GET_STATION_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return CORE_GET_STATION_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return CORE_GET_STATION_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return CORE_GET_DEVICE_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return CORE_GET_DEVICE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return CORE_GET_DEVICE_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_GET_DEVICE_BY_PLANTCODE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_GET_DEVICE_BY_PLANTCODE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CORE_GET_DEVICE_BY_PLANTCODE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CORE_GET_DEVICE_KPI_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return CORE_GET_DEVICE_KPI_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CORE_GET_DEVICE_KPI_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CORE_GET_DEVICE_FIVE_MINUTES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CORE_GET_DEVICE_FIVE_MINUTES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_GET_DEVICE_FIVE_MINUTES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return CORE_GET_KPI_STATION_HOUR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return CORE_GET_KPI_STATION_HOUR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return CORE_GET_KPI_STATION_HOUR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return CORE_GET_KPI_STATION_DAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return CORE_GET_KPI_STATION_DAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return CORE_GET_KPI_STATION_DAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CORE_GET_KPI_STATION_MONTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CORE_GET_KPI_STATION_MONTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return CORE_GET_KPI_STATION_MONTH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CORE_GET_KPI_STATION_YEAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CORE_GET_KPI_STATION_YEAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CORE_GET_KPI_STATION_YEAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return CORE_GET_STATION_REAL_KPI_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return CORE_GET_STATION_REAL_KPI_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return CORE_GET_STATION_REAL_KPI_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return CORE_GET_STATION_REAL_KPI_HOMESITE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return CORE_GET_STATION_REAL_KPI_HOMESITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return CORE_GET_STATION_REAL_KPI_HOMESITE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CORE_GET_ALL_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CORE_GET_ALL_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CORE_GET_ALL_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CORE_GET_DEVICE_KPI_DAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CORE_GET_DEVICE_KPI_DAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CORE_GET_DEVICE_KPI_DAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CORE_GET_DEVICE_KPI_MONTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CORE_GET_DEVICE_KPI_MONTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CORE_GET_DEVICE_KPI_MONTH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return CORE_GET_DEVICE_KPI_YEAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return CORE_GET_DEVICE_KPI_YEAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return CORE_GET_DEVICE_KPI_YEAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_CHANGE_USER_PROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_CHANGE_USER_PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_CHANGE_USER_PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CORE_GET_ALL_COMPANY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CORE_GET_ALL_COMPANY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CORE_GET_ALL_COMPANY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CORE_GET_COMPANY_BY_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CORE_GET_COMPANY_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CORE_GET_COMPANY_BY_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_CHANGE_IMG_SITE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_CHANGE_IMG_SITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_CHANGE_IMG_SITE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CORE_CHANGE_IMG_DEVICE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CORE_CHANGE_IMG_DEVICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CORE_CHANGE_IMG_DEVICE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CORE_DELETE_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CORE_DELETE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CORE_DELETE_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CORE_UPDATE_COMPANY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return CORE_UPDATE_COMPANY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return CORE_UPDATE_COMPANY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CORE_CREATE_COMPANY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CORE_CREATE_COMPANY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CORE_CREATE_COMPANY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CORE_GET_DEVICE_GET_KPI_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CORE_GET_DEVICE_GET_KPI_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CORE_GET_DEVICE_GET_KPI_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return CORE_GET_STATION_KPI_HOUR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return CORE_GET_STATION_KPI_HOUR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return CORE_GET_STATION_KPI_HOUR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return CORE_GET_STATION_KPI_DAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return CORE_GET_STATION_KPI_DAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return CORE_GET_STATION_KPI_DAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return CORE_GET_STATION_KPI_MONTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return CORE_GET_STATION_KPI_MONTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return CORE_GET_STATION_KPI_MONTH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return CORE_GET_STATION_KPI_YEAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return CORE_GET_STATION_KPI_YEAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return CORE_GET_STATION_KPI_YEAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CORE_GET_DEVICE_GET_KPI_DAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CORE_GET_DEVICE_GET_KPI_DAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CORE_GET_DEVICE_GET_KPI_DAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CORE_GET_DEVICE_GET_KPI_MONTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CORE_GET_DEVICE_GET_KPI_MONTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CORE_GET_DEVICE_GET_KPI_MONTH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CORE_GET_DEVICE_GET_KPI_YEAR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CORE_GET_DEVICE_GET_KPI_YEAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CORE_GET_DEVICE_GET_KPI_YEAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_API_AIR_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_API_AIR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_API_AIR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CORE_API_AIR_WIND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CORE_API_AIR_WIND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CORE_API_AIR_WIND_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CORE_API_AIR_17_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CORE_API_AIR_17_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_API_AIR_17_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CORE_API_AIR_WIND_17_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CORE_API_AIR_WIND_17_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CORE_API_AIR_WIND_17_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_API_AIR_PRESSURE_17_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CORE_API_AIR_PRESSURE_17_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_API_AIR_PRESSURE_17_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_API_AIR_CLOUD_17_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_API_AIR_CLOUD_17_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_API_AIR_CLOUD_17_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CORE_API_AIR_PRESSURE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_API_AIR_PRESSURE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CORE_API_AIR_PRESSURE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CORE_API_AIR_CLOUD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CORE_API_AIR_CLOUD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CORE_API_AIR_CLOUD_FAILURE; });
var REQUEST_STATE = 'REQUEST_STATE';
var SET_ERROR = 'SET_ERROR';
var SET_LOADING = 'SET_LOADING';

var LOGOUT = 'LOGOUT';

//AUTH
var CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST';
var CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS';
var CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE';

var AUTH_REQUEST_FORGOT_PASSWORD_REQUEST = 'CORE_AUTH_VERIFY_REQUEST';
var AUTH_REQUEST_FORGOT_PASSWORD_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS';
var AUTH_REQUEST_FORGOT_PASSWORD_FAILURE = 'CORE_AUTH_VERIFY_FAILURE';

var CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST';
var CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS';
var CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE';

var CORE_LOAD_USER_BY_ID_REQUEST = 'CORE_LOAD_USER_BY_ID_REQUEST';
var CORE_LOAD_USER_BY_ID_SUCCESS = 'CORE_LOAD_USER_BY_ID_SUCCESS';
var CORE_LOAD_USER_BY_ID_FAILURE = 'CORE_LOAD_USER_BY_ID_FAILURE';

var CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST';
var CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS';
var CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE';

var CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST';
var CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS';
var CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE';

var CORE_LOAD_USER_GROUP_REQUEST = 'CORE_LOAD_USER_GROUP_REQUEST';
var CORE_LOAD_USER_GROUP_SUCCESS = 'CORE_LOAD_USER_GROUP_SUCCESS';
var CORE_LOAD_USER_GROUP_FAILURE = 'CORE_LOAD_USER_GROUP_FAILURE';

var CORE_LOAD_USER_GROUP_BY_ID_REQUEST = 'CORE_LOAD_USER_GROUP_BY_ID_REQUEST';
var CORE_LOAD_USER_GROUP_BY_ID_SUCCESS = 'CORE_LOAD_USER_GROUP_BY_ID_SUCCESS';
var CORE_LOAD_USER_GROUP_BY_ID_FAILURE = 'CORE_LOAD_USER_GROUP_BY_ID_FAILURE';

var CORE_CREATE_USER_GROUP_REQUEST = 'CORE_CREATE_USER_GROUP_REQUEST';
var CORE_CREATE_USER_GROUP_SUCCESS = 'CORE_CREATE_USER_GROUP_SUCCESS';
var CORE_CREATE_USER_GROUP_FAILURE = 'CORE_CREATE_USER_GROUP_FAILURE';

var CORE_UPDATE_USER_GROUP_REQUEST = 'CORE_UPDATE_USER_GROUP_REQUEST';
var CORE_UPDATE_USER_GROUP_SUCCESS = 'CORE_UPDATE_USER_GROUP_SUCCESS';
var CORE_UPDATE_USER_GROUP_FAILURE = 'CORE_UPDATE_USER_GROUP_FAILURE';

var CORE_DELETE_USER_GROUP_REQUEST = 'CORE_DELETE_USER_GROUP_REQUEST';
var CORE_DELETE_USER_GROUP_SUCCESS = 'CORE_DELETE_USER_GROUP_SUCCESS';
var CORE_DELETE_USER_GROUP_FAILURE = 'CORE_DELETE_USER_GROUP_FAILURE';

var CORE_LOAD_SITE_REQUEST = 'CORE_LOAD_SITE_REQUEST';
var CORE_LOAD_SITE_SUCCESS = 'CORE_LOAD_SITE_SUCCESS';
var CORE_LOAD_SITE_FAILURE = 'CORE_LOAD_SITE_FAILURE';

var CORE_LOAD_SITE_BY_ID_REQUEST = 'CORE_LOAD_SITE_BY_ID_REQUEST';
var CORE_LOAD_SITE_BY_ID_SUCCESS = 'CORE_LOAD_SITE_BY_ID_SUCCESS';
var CORE_LOAD_SITE_BY_ID_FAILURE = 'CORE_LOAD_SITE_BY_ID_FAILURE';

var CORE_CREATE_SITE_REQUEST = 'CORE_CREATE_SITE_REQUEST';
var CORE_CREATE_SITE_SUCCESS = 'CORE_CREATE_SITE_SUCCESS';
var CORE_CREATE_SITE_FAILURE = 'CORE_CREATE_SITE_FAILURE';

var CORE_UPDATE_SITE_REQUEST = 'CORE_UPDATE_SITE_REQUEST';
var CORE_UPDATE_SITE_SUCCESS = 'CORE_UPDATE_SITE_SUCCESS';
var CORE_UPDATE_SITE_FAILURE = 'CORE_UPDATE_SITE_FAILURE';

var CORE_DELETE_SITE_REQUEST = 'CORE_DELETE_SITE_REQUEST';
var CORE_DELETE_SITE_SUCCESS = 'CORE_DELETE_SITE_SUCCESS';
var CORE_DELETE_SITE_FAILURE = 'CORE_DELETE_SITE_FAILURE';

var CORE_LOAD_STATION_REQUEST = 'CORE_LOAD_STATION_REQUEST';
var CORE_LOAD_STATION_SUCCESS = 'CORE_LOAD_STATION_SUCCESS';
var CORE_LOAD_STATION_FAILURE = 'CORE_LOAD_STATION_FAILURE';

var CORE_LOAD_STATION_BY_ID_REQUEST = 'CORE_LOAD_STATION_BY_ID_REQUEST';
var CORE_LOAD_STATION_BY_ID_SUCCESS = 'CORE_LOAD_STATION_BY_ID_SUCCESS';
var CORE_LOAD_STATION_BY_ID_FAILURE = 'CORE_LOAD_STATION_BY_ID_FAILURE';

var CORE_GET_REPORT_REQUEST = 'CORE_GET_REPORT_REQUEST';
var CORE_GET_REPORT_SUCCESS = 'CORE_GET_REPORT_SUCCESS';
var CORE_GET_REPORT_FAILURE = 'CORE_GET_REPORT_FAILURE';

var CORE_GET_STATION_REQUEST = 'CORE_GET_STATION_REQUEST';
var CORE_GET_STATION_SUCCESS = 'CORE_GET_STATION_SUCCESS';
var CORE_GET_STATION_FAILURE = 'CORE_GET_STATION_FAILURE';

var CORE_GET_EXCEL_REPORT_REQUEST = 'CORE_GET_EXCEL_REPORT_REQUEST';
var CORE_GET_EXCEL_REPORT_SUCCESS = 'CORE_GET_EXCEL_REPORT_SUCCESS';
var CORE_GET_EXCEL_REPORT_FAILURE = 'CORE_GET_EXCEL_REPORT_FAILURE';

var CORE_GET_STATION_LIST_REQUEST = 'CORE_GET_STATION_LIST_REQUEST';
var CORE_GET_STATION_LIST_SUCCESS = 'CORE_GET_STATION_LIST_SUCCESS';
var CORE_GET_STATION_LIST_FAILURE = 'CORE_GET_STATION_LIST_FAILURE';

var CORE_GET_DEVICE_LIST_REQUEST = 'CORE_GET_DEVICE_LIST_REQUEST';
var CORE_GET_DEVICE_LIST_SUCCESS = 'CORE_GET_DEVICE_LIST_SUCCESS';
var CORE_GET_DEVICE_LIST_FAILURE = 'CORE_GET_DEVICE_LIST_FAILURE';

var CORE_GET_DEVICE_BY_PLANTCODE_REQUEST = 'CORE_GET_DEVICE_BY_PLANTCODE_REQUEST';
var CORE_GET_DEVICE_BY_PLANTCODE_SUCCESS = 'CORE_GET_DEVICE_BY_PLANTCODE_SUCCESS';
var CORE_GET_DEVICE_BY_PLANTCODE_FAILURE = 'CORE_GET_DEVICE_BY_PLANTCODE_FAILURE';

var CORE_GET_DEVICE_KPI_REQUEST = 'CORE_GET_DEVICE_KPI_REQUEST';
var CORE_GET_DEVICE_KPI_SUCCESS = 'CORE_GET_DEVICE_KPI_SUCCESS';
var CORE_GET_DEVICE_KPI_FAILURE = 'CORE_GET_DEVICE_KPI_FAILURE';

var CORE_GET_DEVICE_FIVE_MINUTES_REQUEST = 'CORE_GET_DEVICE_FIVE_MINUTES_REQUEST';
var CORE_GET_DEVICE_FIVE_MINUTES_SUCCESS = 'CORE_GET_DEVICE_FIVE_MINUTES_SUCCESS';
var CORE_GET_DEVICE_FIVE_MINUTES_FAILURE = 'CORE_GET_DEVICE_FIVE_MINUTES_FAILURE';

var CORE_GET_KPI_STATION_HOUR_REQUEST = 'CORE_GET_KPI_STATION_HOUR_REQUEST';
var CORE_GET_KPI_STATION_HOUR_SUCCESS = 'CORE_GET_KPI_STATION_HOUR_SUCCESS';
var CORE_GET_KPI_STATION_HOUR_FAILURE = 'CORE_GET_KPI_STATION_HOUR_FAILURE';

var CORE_GET_KPI_STATION_DAY_REQUEST = 'CORE_GET_KPI_STATION_DAY_REQUEST';
var CORE_GET_KPI_STATION_DAY_SUCCESS = 'CORE_GET_KPI_STATION_DAY_SUCCESS';
var CORE_GET_KPI_STATION_DAY_FAILURE = 'CORE_GET_KPI_STATION_DAY_FAILURE';

var CORE_GET_KPI_STATION_MONTH_REQUEST = 'CORE_GET_KPI_STATION_MONTH_REQUEST';
var CORE_GET_KPI_STATION_MONTH_SUCCESS = 'CORE_GET_KPI_STATION_MONTH_SUCCESS';
var CORE_GET_KPI_STATION_MONTH_FAILURE = 'CORE_GET_KPI_STATION_MONTH_FAILURE';

var CORE_GET_KPI_STATION_YEAR_REQUEST = 'CORE_GET_KPI_STATION_YEAR_REQUEST';
var CORE_GET_KPI_STATION_YEAR_SUCCESS = 'CORE_GET_KPI_STATION_YEAR_SUCCESS';
var CORE_GET_KPI_STATION_YEAR_FAILURE = 'CORE_GET_KPI_STATION_YEAR_FAILURE';

var CORE_GET_STATION_REAL_KPI_REQUEST = 'CORE_GET_STATION_REAL_KPI_REQUEST';
var CORE_GET_STATION_REAL_KPI_SUCCESS = 'CORE_GET_STATION_REAL_KPI_SUCCESS';
var CORE_GET_STATION_REAL_KPI_FAILURE = 'CORE_GET_STATION_REAL_KPI_FAILURE';

var CORE_GET_STATION_REAL_KPI_HOMESITE_REQUEST = 'CORE_GET_STATION_REAL_KPI_HOMESITE_REQUEST';
var CORE_GET_STATION_REAL_KPI_HOMESITE_SUCCESS = 'CORE_GET_STATION_REAL_KPI_HOMESITE_SUCCESS';
var CORE_GET_STATION_REAL_KPI_HOMESITE_FAILURE = 'CORE_GET_STATION_REAL_KPI_HOMESITE_FAILURE';

var CORE_GET_ALL_DEVICE_REQUEST = 'CORE_GET_ALL_DEVICE_REQUEST';
var CORE_GET_ALL_DEVICE_SUCCESS = 'CORE_GET_ALL_DEVICE_SUCCESS';
var CORE_GET_ALL_DEVICE_FAILURE = 'CORE_GET_ALL_DEVICE_FAILURE';

var CORE_GET_DEVICE_KPI_DAY_REQUEST = 'CORE_GET_DEVICE_KPI_DAY_REQUEST';
var CORE_GET_DEVICE_KPI_DAY_SUCCESS = 'CORE_GET_DEVICE_KPI_DAY_SUCCESS';
var CORE_GET_DEVICE_KPI_DAY_FAILURE = 'CORE_GET_DEVICE_KPI_DAY_FAILURE';

var CORE_GET_DEVICE_KPI_MONTH_REQUEST = 'CORE_GET_DEVICE_KPI_MONTH_REQUEST';
var CORE_GET_DEVICE_KPI_MONTH_SUCCESS = 'CORE_GET_DEVICE_KPI_MONTH_SUCCESS';
var CORE_GET_DEVICE_KPI_MONTH_FAILURE = 'CORE_GET_DEVICE_KPI_MONTH_FAILURE';

var CORE_GET_DEVICE_KPI_YEAR_REQUEST = 'CORE_GET_DEVICE_KPI_YEAR_REQUEST';
var CORE_GET_DEVICE_KPI_YEAR_SUCCESS = 'CORE_GET_DEVICE_KPI_YEAR_SUCCESS';
var CORE_GET_DEVICE_KPI_YEAR_FAILURE = 'CORE_GET_DEVICE_KPI_YEAR_FAILURE';

var CORE_CHANGE_USER_PROFILE_REQUEST = 'CORE_CHANGE_USER_PROFILE_REQUEST';
var CORE_CHANGE_USER_PROFILE_SUCCESS = 'CORE_CHANGE_USER_PROFILE_SUCCESS';
var CORE_CHANGE_USER_PROFILE_FAILURE = 'CORE_CHANGE_USER_PROFILE_FAILURE';

var CORE_GET_ALL_COMPANY_REQUEST = 'CORE_GET_ALL_COMPANY_REQUEST';
var CORE_GET_ALL_COMPANY_SUCCESS = 'CORE_GET_ALL_COMPANY_SUCCESS';
var CORE_GET_ALL_COMPANY_FAILURE = 'CORE_GET_ALL_COMPANY_FAILURE';

var CORE_GET_COMPANY_BY_ID_REQUEST = 'CORE_GET_COMPANY_BY_ID_REQUEST';
var CORE_GET_COMPANY_BY_ID_SUCCESS = 'CORE_GET_COMPANY_BY_ID_SUCCESS';
var CORE_GET_COMPANY_BY_ID_FAILURE = 'CORE_GET_COMPANY_BY_ID_FAILURE';

var CORE_CHANGE_IMG_SITE_REQUEST = 'CORE_CHANGE_IMG_SITE_REQUEST';
var CORE_CHANGE_IMG_SITE_SUCCESS = 'CORE_CHANGE_IMG_SITE_SUCCESS';
var CORE_CHANGE_IMG_SITE_FAILURE = 'CORE_CHANGE_IMG_SITE_FAILURE';

var CORE_CHANGE_IMG_DEVICE_REQUEST = 'CORE_CHANGE_IMG_DEVICE_REQUEST';
var CORE_CHANGE_IMG_DEVICE_SUCCESS = 'CORE_CHANGE_IMG_DEVICE_SUCCESS';
var CORE_CHANGE_IMG_DEVICE_FAILURE = 'CORE_CHANGE_IMG_DEVICE_FAILURE';

var CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST';
var CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS';
var CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE';

var CORE_UPDATE_COMPANY_REQUEST = 'CORE_UPDATE_COMPANY_REQUEST';
var CORE_UPDATE_COMPANY_SUCCESS = 'CORE_UPDATE_COMPANY_SUCCESS';
var CORE_UPDATE_COMPANY_FAILURE = 'CORE_UPDATE_COMPANY_FAILURE';

var CORE_CREATE_COMPANY_REQUEST = 'CORE_CREATE_COMPANY_REQUEST';
var CORE_CREATE_COMPANY_SUCCESS = 'CORE_CREATE_COMPANY_SUCCESS';
var CORE_CREATE_COMPANY_FAILURE = 'CORE_CREATE_COMPANY_FAILURE';

var CORE_GET_DEVICE_GET_KPI_REQUEST = 'CORE_GET_DEVICE_GET_KPI_REQUEST';
var CORE_GET_DEVICE_GET_KPI_SUCCESS = 'CORE_GET_DEVICE_GET_KPI_SUCCESS';
var CORE_GET_DEVICE_GET_KPI_FAILURE = 'CORE_GET_DEVICE_GET_KPI_FAILURE';

var CORE_GET_STATION_KPI_HOUR_REQUEST = 'CORE_GET_STATION_KPI_HOUR_REQUEST';
var CORE_GET_STATION_KPI_HOUR_SUCCESS = 'CORE_GET_STATION_KPI_HOUR_SUCCESS';
var CORE_GET_STATION_KPI_HOUR_FAILURE = 'CORE_GET_STATION_KPI_HOUR_FAILURE';

var CORE_GET_STATION_KPI_DAY_REQUEST = 'CORE_GET_STATION_KPI_DAY_REQUEST';
var CORE_GET_STATION_KPI_DAY_SUCCESS = 'CORE_GET_STATION_KPI_DAY_SUCCESS';
var CORE_GET_STATION_KPI_DAY_FAILURE = 'CORE_GET_STATION_KPI_DAY_FAILURE';

var CORE_GET_STATION_KPI_MONTH_REQUEST = 'CORE_GET_STATION_KPI_MONTH_REQUEST';
var CORE_GET_STATION_KPI_MONTH_SUCCESS = 'CORE_GET_STATION_KPI_MONTH_SUCCESS';
var CORE_GET_STATION_KPI_MONTH_FAILURE = 'CORE_GET_STATION_KPI_MONTH_FAILURE';

var CORE_GET_STATION_KPI_YEAR_REQUEST = 'CORE_GET_STATION_KPI_YEAR_REQUEST';
var CORE_GET_STATION_KPI_YEAR_SUCCESS = 'CORE_GET_STATION_KPI_YEAR_SUCCESS';
var CORE_GET_STATION_KPI_YEAR_FAILURE = 'CORE_GET_STATION_KPI_YEAR_FAILURE';

var CORE_GET_DEVICE_GET_KPI_DAY_REQUEST = 'CORE_GET_DEVICE_GET_KPI_DAY_REQUEST';
var CORE_GET_DEVICE_GET_KPI_DAY_SUCCESS = 'CORE_GET_DEVICE_GET_KPI_DAY_SUCCESS';
var CORE_GET_DEVICE_GET_KPI_DAY_FAILURE = 'CORE_GET_DEVICE_GET_KPI_DAY_FAILURE';

var CORE_GET_DEVICE_GET_KPI_MONTH_REQUEST = 'CORE_GET_DEVICE_GET_KPI_MONTH_REQUEST';
var CORE_GET_DEVICE_GET_KPI_MONTH_SUCCESS = 'CORE_GET_DEVICE_GET_KPI_MONTH_SUCCESS';
var CORE_GET_DEVICE_GET_KPI_MONTH_FAILURE = 'CORE_GET_DEVICE_GET_KPI_MONTH_FAILURE';

var CORE_GET_DEVICE_GET_KPI_YEAR_REQUEST = 'CORE_GET_DEVICE_GET_KPI_YEAR_REQUEST';
var CORE_GET_DEVICE_GET_KPI_YEAR_SUCCESS = 'CORE_GET_DEVICE_GET_KPI_YEAR_SUCCESS';
var CORE_GET_DEVICE_GET_KPI_YEAR_FAILURE = 'CORE_GET_DEVICE_GET_KPI_YEAR_FAILURE';

var CORE_API_AIR_REQUEST = 'CORE_API_AIR_REQUEST';
var CORE_API_AIR_SUCCESS = 'CORE_API_AIR_SUCCESS';
var CORE_API_AIR_FAILURE = 'CORE_API_AIR_FAILURE';

var CORE_API_AIR_WIND_REQUEST = 'CORE_API_AIR_WIND_REQUEST';
var CORE_API_AIR_WIND_SUCCESS = 'CORE_API_AIR_WIND_SUCCESS';
var CORE_API_AIR_WIND_FAILURE = 'CORE_API_AIR_WIND_FAILURE';

var CORE_API_AIR_17_REQUEST = 'CORE_API_AIR_17_REQUEST';
var CORE_API_AIR_17_SUCCESS = 'CORE_API_AIR_17_SUCCESS';
var CORE_API_AIR_17_FAILURE = 'CORE_API_AIR_17_FAILURE';

var CORE_API_AIR_WIND_17_REQUEST = 'CORE_API_AIR_WIND_17_REQUEST';
var CORE_API_AIR_WIND_17_SUCCESS = 'CORE_API_AIR_WIND_17_SUCCESS';
var CORE_API_AIR_WIND_17_FAILURE = 'CORE_API_AIR_WIND_17_FAILURE';

var CORE_API_AIR_PRESSURE_17_REQUEST = 'CORE_API_AIR_PRESSURE_17_REQUEST';
var CORE_API_AIR_PRESSURE_17_SUCCESS = 'CORE_API_AIR_PRESSURE_17_SUCCESS';
var CORE_API_AIR_PRESSURE_17_FAILURE = 'CORE_API_AIR_PRESSURE_17_FAILURE';

var CORE_API_AIR_CLOUD_17_REQUEST = 'CORE_API_AIR_CLOUD_17_REQUEST';
var CORE_API_AIR_CLOUD_17_SUCCESS = 'CORE_API_AIR_CLOUD_17_SUCCESS';
var CORE_API_AIR_CLOUD_17_FAILURE = 'CORE_API_AIR_CLOUD_17_FAILURE';

var CORE_API_AIR_PRESSURE_REQUEST = 'CORE_API_AIR_PRESSURE_REQUEST';
var CORE_API_AIR_PRESSURE_SUCCESS = 'CORE_API_AIR_PRESSURE_SUCCESS';
var CORE_API_AIR_PRESSURE_FAILURE = 'CORE_API_AIR_PRESSURE_FAILURE';

var CORE_API_AIR_CLOUD_REQUEST = 'CORE_API_AIR_CLOUD_REQUEST';
var CORE_API_AIR_CLOUD_SUCCESS = 'CORE_API_AIR_CLOUD_SUCCESS';
var CORE_API_AIR_CLOUD_FAILURE = 'CORE_API_AIR_CLOUD_FAILURE';

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(51);


/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(12);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(56);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 5 modules
var react_router_dom = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 15 modules
var es = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(75);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(76);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var lib = __webpack_require__(83);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 605 modules
var dist_es = __webpack_require__(22);

// CONCATENATED MODULE: ./src/app/components/features/share/loadingInline.js



var loadingInline_LoaderExampleInlineCentered = function LoaderExampleInlineCentered() {
    return react_default.a.createElement(
        dist_es["j" /* Loader */],
        { active: true, inline: 'centered', size: 'large' },
        'Loading'
    );
};

/* harmony default export */ var loadingInline = (loadingInline_LoaderExampleInlineCentered);
// CONCATENATED MODULE: ./src/app/components/features/share/loadable/loadableRoute.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var loadableRoute_Loading = function Loading() {
    return react_default.a.createElement(
        'div',
        { className: 'module loadableRoute' },
        react_default.a.createElement(loadingInline, null)
    );
};

/* harmony default export */ var loadableRoute = (function (opts) {
    return lib_default()(_extends({
        loading: loadableRoute_Loading
    }, opts));
});
// EXTERNAL MODULE: ./src/lib/index.js + 2 modules
var src_lib = __webpack_require__(41);

// EXTERNAL MODULE: ./src/app/business/authManager.js
var authManager = __webpack_require__(49);

// CONCATENATED MODULE: ./src/app/routes/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var Auth = {
    isAuthenticated: function isAuthenticated() {
        var cookies = Object(src_lib["h" /* getAllCookies */])();
        var isAuth = false;

        if (cookies && cookies[src_lib["e" /* TOKEN */]] && cookies[src_lib["f" /* USER_ID */]]) {
            isAuth = true;
        }
        return isAuth;
    },
    isDevice: function isDevice() {
        var isAdmin = Object(src_lib["i" /* getDeviceAdmin */])();
        return isAdmin.toString() === 'true';
    },
    isAdmin: function isAdmin() {
        var isAdmin = Object(src_lib["j" /* getIsAdmin */])();
        return isAdmin.toString() === 'true';
    }

};
var routePermission_AdminPrivateRoute = function AdminPrivateRoute(_ref) {
    var Component = _ref.component,
        Layout = _ref.layout,
        staticContext = _ref.staticContext,
        rest = _objectWithoutProperties(_ref, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === true && Auth.isAdmin() === false && props.match.url !== '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_PrivateRoute = function PrivateRoute(_ref2) {
    var Component = _ref2.component,
        Layout = _ref2.layout,
        staticContext = _ref2.staticContext,
        rest = _objectWithoutProperties(_ref2, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            var inComingPath = props && props.match && props.match.url;
            authManager["a" /* default */].setUrlIncoming(inComingPath);

            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_PublicRoute = function PublicRoute(_ref3) {
    var Component = _ref3.component,
        Layout = _ref3.layout,
        staticContext = _ref3.staticContext,
        rest = _objectWithoutProperties(_ref3, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === true && props.match.url === '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/dashboard' });
            }
            if (props.match.url === '/') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }
            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return null;
                }
            }
        }
    }));
};


// CONCATENATED MODULE: ./src/app/routes/Routes.js





//Layout
var LayoutBlank = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 393));
    }
});
var LayoutMaster = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 394));
    }
});
var LayoutOther = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 395));
    }
});
var LayoutMasterLocation = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 396));
    }
});
// const layoutMasterChartCentral1 = LoadableRoute({
//     loader: () => import('../components/layout/controllers/layoutMasterChartCentral1')
// })
// const LayoutMasterData = LoadableRoute({
//     loader: () => import('../components/layout/controllers/layoutMasterData')
// })

// Home
var HomeController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 397));
    }
});
// MapView
var HomeSiteController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 398));
    }
});
var NorthernRegionController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 399));
    }
});
var NortheasternRegionController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 400));
    }
});
var SouthernRegionController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 401));
    }
});
// TableView
var homeStationController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 402));
    }
});

// DataView
var HomeDeviceController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 403));
    }
});
// User
var UserController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 404));
    }
});
// Login
var LoginController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 405));
    }
});
// Forgot Password
var ForgotPasswordController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 406));
    }
});
// Setting Admin
var SettingAdminController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 407));
    }
});
// Report
var ReportController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 408));
    }
});
// const DashboardController = LoadableRoute({
//     loader: () => import('../components/features/dashboard/controllers/dashboardController')
// })
var SiteController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 409));
    }
});
var CreateSiteController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 410));
    }
});
var UpdateSiteController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 411));
    }
});

var ViewSiteController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 412));
    }
});

var UserControllerAdminSetting = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 413));
    }
});
var CreateUserController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 414));
    }
});
var UpdateUserController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 415));
    }
});
var ViewUserController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 416));
    }
});

var UserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 417));
    }
});
var CreateUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 418));
    }
});
var UpdateUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 419));
    }
});
var ViewUserGroupController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 420));
    }
});
// const ProfileController = LoadableRoute({
//     loader: () => import('../components/features/profile/controllers/profileController')
// })
var SettingDeviceController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 421));
    }
});
var ViewSettingDeviceController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 422));
    }
});
var UpdateSettingDeviceController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 423));
    }
});
var CompanyController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 424));
    }
});
var CreateCompanyController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 425));
    }
});
var ViewCompanyController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 426));
    }
});
var UpdateCompanyController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 427));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        react_router_dom["d" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/site/update/:id', component: UpdateSiteController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/site/view/:id', component: ViewSiteController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/device/view/:id', component: ViewSettingDeviceController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/device/update/:id', component: UpdateSettingDeviceController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/company/view/:id', component: ViewCompanyController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/company/update/:id', component: UpdateCompanyController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/company/create', component: CreateCompanyController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/user/update/:id', component: UpdateUserController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/user/view/:id', component: ViewUserController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/userGroup/update/:id', component: UpdateUserGroupController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/userGroup/view/:id', component: ViewUserGroupController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/site/create', component: CreateSiteController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/user/create', component: CreateUserController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/userGroup/create', component: CreateUserGroupController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/device', component: SettingDeviceController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/company', component: CompanyController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/site', component: SiteController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/user', component: UserControllerAdminSetting, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting/userGroup', component: UserGroupController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/dashboard/device/:id/:id2/:id3/:id4', component: HomeDeviceController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/dashboard/station/:id/:id2', component: homeStationController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/dashboard/site/:id', component: HomeSiteController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/dashboard/northernRegion', component: NorthernRegionController, layout: LayoutMasterLocation }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/dashboard/northeasternRegion', component: NortheasternRegionController, layout: LayoutMasterLocation }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/dashboard/southernRegion', component: SouthernRegionController, layout: LayoutMasterLocation }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/dashboard', component: HomeController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/users', component: UserController, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/adminSetting', component: SettingAdminController, layout: LayoutOther }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/report', component: ReportController, layout: LayoutMaster }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/forgotPassword', component: ForgotPasswordController, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/login', component: LoginController, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/', component: LoginController, layout: LayoutBlank })
    );
});
// CONCATENATED MODULE: ./src/app/routes/App.js



/* harmony default export */ var App = (function () {
  return react_default.a.createElement(Routes, null);
});
// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(32);

// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(5);

// CONCATENATED MODULE: ./src/app/redux/actions/actionsCallAPI.js
var actionsCallAPI__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// import { CALL_API } from 'Middlewares'


function actionsCallAPI_setError(errorList, newError, isShow) {
    var mapError = [];
    if (errorList && Array.isArray(errorList)) {
        if (isShow === true) {
            errorList.forEach(function (e) {
                mapError.push(actionsCallAPI__extends({}, e, { isShow: true }));
            });
        } else {
            mapError = mapError.concat(errorList);
        }
    }
    if (newError) {
        mapError.push(actionsCallAPI__extends({}, newError, { isShow: false }));
    }

    return {
        type: types["_129" /* SET_ERROR */],
        error: mapError
    };
}

function actionsCallAPI_setLoading(isLoading) {
    return {
        type: types["_130" /* SET_LOADING */],
        isLoading: isLoading
    };
}
// EXTERNAL MODULE: ./src/app/redux/selectors/selectorCallAPI.js
var selectorCallAPI = __webpack_require__(35);

// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(21);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(33);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(34);
var ReactToastify_default = /*#__PURE__*/__webpack_require__.n(ReactToastify);

// CONCATENATED MODULE: ./src/app/components/features/share/modal/errorModal.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var errorModal_ErrorModal = function (_React$Component) {
    _inherits(ErrorModal, _React$Component);

    function ErrorModal(props) {
        _classCallCheck(this, ErrorModal);

        var _this = _possibleConstructorReturn(this, (ErrorModal.__proto__ || Object.getPrototypeOf(ErrorModal)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(ErrorModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                errorList = _props.errorList,
                t = _props.t;


            return react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(react_toastify_esm["a" /* ToastContainer */], {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    newestOnTop: false,
                    closeOnClick: true,
                    rtl: false,
                    pauseOnFocusLoss: true,
                    draggable: true,
                    pauseOnHover: true
                }),
                errorList.length > 0 && react_toastify_esm["b" /* toast */].error(react_default.a.createElement(
                    react_default.a.Fragment,
                    null,
                    react_default.a.createElement(
                        'p',
                        { style: { fontWeight: 'bold', color: 'white', fontSize: '1em' } },
                        t('common.somethingWrong')
                    ),
                    errorList.map(function (e, i) {
                        var message = e.message,
                            path = e.path,
                            code = e.code;

                        var data = { statusText: message, statusCode: path, code: code };
                        return react_default.a.createElement(errorModal_ItemErrorObj, { key: i, data: data });
                    })
                ), {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    onClose: function onClose() {
                        return _this2.props.setError(null, null, true);
                    }
                })
            );
        }
    }]);

    return ErrorModal;
}(react_default.a.Component);

var errorModal_ItemErrorObj = function ItemErrorObj(props) {
    var data = props.data;


    return react_default.a.createElement(
        dist_es["i" /* List */].Item,
        { className: 'itemError' },
        react_default.a.createElement(
            dist_es["i" /* List */].Content,
            null,
            data.code && react_default.a.createElement(
                'p',
                { style: { color: 'white', fontSize: '0.9em' } },
                data.code
            ),
            react_default.a.createElement(
                'p',
                { style: { color: 'white', fontSize: '0.9em' }, className: 'detailError header' },
                data.statusText
            )
        )
    );
};

/* harmony default export */ var errorModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
    return {
        errorList: Object(selectorCallAPI["a" /* getErrorList */])(state)
    };
}, function (dispatch, _ref) {
    var history = _ref.history;
    return {
        setError: function setError(errorList, newError, isShow) {
            dispatch(actionsCallAPI_setError(errorList, newError, isShow));
        }
    };
}), Object(Recompose["b" /* lifecycle */])({}))(errorModal_ErrorModal));
// CONCATENATED MODULE: ./src/app/components/features/share/loading.js




var loading_Loading = function Loading(props) {
    var active = props && props.isActive ? props.isActive : false;

    return react_default.a.createElement(
        dist_es["c" /* Dimmer */],
        { style: { position: 'fixed' }, active: active },
        react_default.a.createElement(loadingInline, null)
    );
};

/* harmony default export */ var share_loading = (loading_Loading);
// CONCATENATED MODULE: ./src/app/components/features/share/modal/loadingModal.js
var loadingModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function loadingModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function loadingModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function loadingModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var loadingModal_LoadingModal = function (_React$Component) {
    loadingModal__inherits(LoadingModal, _React$Component);

    function LoadingModal(props) {
        loadingModal__classCallCheck(this, LoadingModal);

        var _this = loadingModal__possibleConstructorReturn(this, (LoadingModal.__proto__ || Object.getPrototypeOf(LoadingModal)).call(this, props));

        _this.state = {
            isLoading: false
        };
        return _this;
    }

    loadingModal__createClass(LoadingModal, [{
        key: 'render',
        value: function render() {
            var loading = this.props.loading;


            return react_default.a.createElement(share_loading, { isActive: loading });
        }
    }]);

    return LoadingModal;
}(react_default.a.Component);

/* harmony default export */ var loadingModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
    return {
        loading: Object(selectorCallAPI["b" /* getLoading */])(state)
    };
}, function (dispatch, _ref) {
    var history = _ref.history;
    return {
        setLoading: function setLoading(isLoading) {
            dispatch(actionsCallAPI_setLoading(isLoading));
        }
    };
}), Object(Recompose["b" /* lifecycle */])({}))(loadingModal_LoadingModal));
// EXTERNAL MODULE: ./src/app/components/scss/index.scss
var scss = __webpack_require__(101);
var scss_default = /*#__PURE__*/__webpack_require__.n(scss);

// CONCATENATED MODULE: ./src/app/routes/Root.js









var store = configureStore_default()();

/* harmony default export */ var Root = (function () {
	return react_default.a.createElement(
		es["a" /* Provider */],
		{ store: store },
		react_default.a.createElement(
			react_router_dom["a" /* BrowserRouter */],
			null,
			react_default.a.createElement(
				react_default.a.Fragment,
				null,
				react_default.a.createElement(App, null),
				react_default.a.createElement(errorModal, null),
				react_default.a.createElement(loadingModal, null)
			)
		)
	);
});
// EXTERNAL MODULE: ./src/wording/language/en/common.json
var common = __webpack_require__(109);
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./src/wording/language/en/login.json
var login = __webpack_require__(110);
var login_default = /*#__PURE__*/__webpack_require__.n(login);

// EXTERNAL MODULE: ./src/wording/language/en/menu.json
var menu = __webpack_require__(111);
var menu_default = /*#__PURE__*/__webpack_require__.n(menu);

// EXTERNAL MODULE: ./src/wording/language/en/settings.json
var settings = __webpack_require__(112);
var settings_default = /*#__PURE__*/__webpack_require__.n(settings);

// EXTERNAL MODULE: ./src/wording/language/en/share.json
var share = __webpack_require__(113);
var share_default = /*#__PURE__*/__webpack_require__.n(share);

// EXTERNAL MODULE: ./src/wording/language/en/form.json
var en_form = __webpack_require__(114);
var form_default = /*#__PURE__*/__webpack_require__.n(en_form);

// CONCATENATED MODULE: ./src/wording/language/en.js
var en__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var en = (en__extends({}, common_default.a, login_default.a, menu_default.a, settings_default.a, share_default.a, form_default.a));
// EXTERNAL MODULE: ./src/wording/language/th/common.json
var th_common = __webpack_require__(115);
var th_common_default = /*#__PURE__*/__webpack_require__.n(th_common);

// EXTERNAL MODULE: ./src/wording/language/th/login.json
var th_login = __webpack_require__(116);
var th_login_default = /*#__PURE__*/__webpack_require__.n(th_login);

// EXTERNAL MODULE: ./src/wording/language/th/menu.json
var th_menu = __webpack_require__(117);
var th_menu_default = /*#__PURE__*/__webpack_require__.n(th_menu);

// EXTERNAL MODULE: ./src/wording/language/th/settings.json
var th_settings = __webpack_require__(118);
var th_settings_default = /*#__PURE__*/__webpack_require__.n(th_settings);

// EXTERNAL MODULE: ./src/wording/language/th/report.json
var report = __webpack_require__(119);
var report_default = /*#__PURE__*/__webpack_require__.n(report);

// EXTERNAL MODULE: ./src/wording/language/th/form.json
var th_form = __webpack_require__(120);
var th_form_default = /*#__PURE__*/__webpack_require__.n(th_form);

// CONCATENATED MODULE: ./src/wording/language/th.js
var th__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var th = (th__extends({}, th_common_default.a, th_login_default.a, th_menu_default.a, th_settings_default.a, report_default.a, th_form_default.a));
// CONCATENATED MODULE: ./src/index.js










Object(react_switch_lang["setTranslations"])({ en: en, th: th });

Object(react_switch_lang["setDefaultLanguage"])('en');

if (Object(react_switch_lang["getLanguage"])() === 'th' || Object(react_switch_lang["getLanguage"])() === 'en') {
    Object(react_switch_lang["setLanguage"])(Object(react_switch_lang["getLanguage"])());
}

Object(react_switch_lang["setLanguageCookie"])('language', { maxAge: 86400 }, undefined);

var src_render = function render(Component) {
    react_dom_default.a.render(react_default.a.createElement(
        react_hot_loader["AppContainer"],
        null,
        react_default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

src_render(Root);

if (false) {
    module.hot.accept('./app/routes/Root', function () {
        return src_render(RootContainer);
    });
}

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(77);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(26);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(78);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(42);

// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(5);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerAuth.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var reducerAuth_initialState = {
    user: null
};

var requestState = types["_128" /* REQUEST_STATE */];
/* harmony default export */ var reducerAuth = ({
    authen: function authen() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerAuth_initialState;
        var action = arguments[1];

        switch (action.type) {
            default:
                return _extends({}, state);
        }
    },

    verifyLogin: function verifyLogin() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["C" /* CORE_AUTH_VERIFY_REQUEST */]:
                return state;
            case types["D" /* CORE_AUTH_VERIFY_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["B" /* CORE_AUTH_VERIFY_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(33);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(34);
var ReactToastify_default = /*#__PURE__*/__webpack_require__.n(ReactToastify);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerCallAPI.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */





var initialStateCallAPI = {
    isLoading: false,
    hasError: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
},
    initialStateArray = [];

/* harmony default export */ var reducerCallAPI = ({
    errorList: function errorList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateArray;
        var action = arguments[1];

        switch (action.type) {
            case types["_129" /* SET_ERROR */]:
                var newError = [];
                if (action && Array.isArray(action.error)) {
                    newError = action.error;
                }
                return newError;

            case types["D" /* CORE_AUTH_VERIFY_SUCCESS */]:
                if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    var _action$payload = action.payload,
                        errors = _action$payload.errors,
                        result = _action$payload.result;

                    var _newError = [];
                    if (!result) {
                        if (Array.isArray(errors)) {
                            errors.map(function (e) {
                                react_toastify_esm["b" /* toast */].error(e.message, {
                                    position: 'top-right',
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined
                                });
                                return e;
                            });
                        }
                    }

                    return _newError;
                }
                return state;
            case types["B" /* CORE_AUTH_VERIFY_FAILURE */]:
                if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    var _action$payload2 = action.payload,
                        code = _action$payload2.code,
                        message = _action$payload2.message,
                        statusText = _action$payload2.statusText,
                        statusCode = _action$payload2.statusCode;
                    var url = action.url;

                    var _newError2 = [];
                    _newError2.push({
                        code: code ? code : '404',
                        message: message,
                        isShow: false,
                        statusText: statusText,
                        statusCode: statusCode,
                        url: url
                    });
                    _newError2.map(function (e) {
                        react_toastify_esm["b" /* toast */].error(e.code + ',' + e.message, {
                            position: 'top-right',
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined
                        });
                        return e;
                    });
                }
                return state;
            default:
                return state;
        }
    },
    isLoading: function isLoading() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            // case CORE_GET_TASKS_BY_ID_REQUEST:
            //     return true
            // case CORE_GET_TASKS_BY_ID_SUCCESS:
            //     return false
            // case CORE_GET_TASKS_BY_ID_FAILURE:
            //     return false
            default:
                return state;
        }
    },
    reducerCallAPI: function reducerCallAPI() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateCallAPI;
        var action = arguments[1];

        switch (action.type) {
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterData/site.js



var site_requestState = types["_128" /* REQUEST_STATE */];

/* harmony default export */ var masterData_site = ({
    sites: function sites() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_96" /* CORE_LOAD_SITE_REQUEST */]:
                return state;
            case types["_97" /* CORE_LOAD_SITE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_95" /* CORE_LOAD_SITE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    site: function site() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_93" /* CORE_LOAD_SITE_BY_ID_REQUEST */]:
                return state;
            case types["_94" /* CORE_LOAD_SITE_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_92" /* CORE_LOAD_SITE_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    siteChangeImg: function siteChangeImg() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["I" /* CORE_CHANGE_IMG_SITE_REQUEST */]:
                return state;
            case types["J" /* CORE_CHANGE_IMG_SITE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["H" /* CORE_CHANGE_IMG_SITE_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAir: function apiDataReportAir() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["t" /* CORE_API_AIR_REQUEST */]:
                return state;
            case types["u" /* CORE_API_AIR_SUCCESS */]:
                if (action.payload) {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        datas = _action$payload4.datas;

                    if (result && datas) {
                        console.log('test fon datas');
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["m" /* CORE_API_AIR_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirWind: function apiDataReportAirWind() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["z" /* CORE_API_AIR_WIND_REQUEST */]:
                return state;
            case types["A" /* CORE_API_AIR_WIND_SUCCESS */]:
                if (action.payload) {
                    var _action$payload5 = action.payload,
                        result = _action$payload5.result,
                        datas = _action$payload5.datas;

                    if (result && datas) {
                        console.log('test fon datas');
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["y" /* CORE_API_AIR_WIND_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirPressure: function apiDataReportAirPressure() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["r" /* CORE_API_AIR_PRESSURE_REQUEST */]:
                return state;
            case types["s" /* CORE_API_AIR_PRESSURE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload6 = action.payload,
                        result = _action$payload6.result,
                        datas = _action$payload6.datas;

                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["q" /* CORE_API_AIR_PRESSURE_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAir17: function apiDataReportAir17() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["e" /* CORE_API_AIR_17_REQUEST */]:
                return state;
            case types["f" /* CORE_API_AIR_17_SUCCESS */]:
                if (action.payload) {
                    var _action$payload7 = action.payload,
                        result = _action$payload7.result,
                        datas = _action$payload7.datas;

                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["d" /* CORE_API_AIR_17_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirWind17: function apiDataReportAirWind17() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["w" /* CORE_API_AIR_WIND_17_REQUEST */]:
                return state;
            case types["x" /* CORE_API_AIR_WIND_17_SUCCESS */]:
                if (action.payload) {
                    var _action$payload8 = action.payload,
                        result = _action$payload8.result,
                        datas = _action$payload8.datas;

                    if (result && datas) {
                        console.log('test fon datas17');
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["v" /* CORE_API_AIR_WIND_17_FAILURE */]:
                return {};
            default:
                return state;
        }
    },

    apiDataReportAirPressure17: function apiDataReportAirPressure17() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["o" /* CORE_API_AIR_PRESSURE_17_REQUEST */]:
                return state;
            case types["p" /* CORE_API_AIR_PRESSURE_17_SUCCESS */]:
                if (action.payload) {
                    var _action$payload9 = action.payload,
                        result = _action$payload9.result,
                        datas = _action$payload9.datas;

                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["n" /* CORE_API_AIR_PRESSURE_17_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirCloud17: function apiDataReportAirCloud17() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["h" /* CORE_API_AIR_CLOUD_17_REQUEST */]:
                return state;
            case types["i" /* CORE_API_AIR_CLOUD_17_SUCCESS */]:
                if (action.payload) {
                    var _action$payload10 = action.payload,
                        result = _action$payload10.result,
                        datas = _action$payload10.datas;

                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["g" /* CORE_API_AIR_CLOUD_17_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirCloud: function apiDataReportAirCloud() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : site_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["k" /* CORE_API_AIR_CLOUD_REQUEST */]:
                return state;
            case types["l" /* CORE_API_AIR_CLOUD_SUCCESS */]:
                if (action.payload) {
                    var _action$payload11 = action.payload,
                        result = _action$payload11.result,
                        datas = _action$payload11.datas;

                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case types["j" /* CORE_API_AIR_CLOUD_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterData/user.js



var user_requestState = types["_128" /* REQUEST_STATE */];

/* harmony default export */ var masterData_user = ({
    users: function users() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_114" /* CORE_LOAD_USER_REQUEST */]:
                return state;
            case types["_115" /* CORE_LOAD_USER_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_107" /* CORE_LOAD_USER_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    user: function user() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_105" /* CORE_LOAD_USER_BY_ID_REQUEST */]:
                return state;
            case types["_106" /* CORE_LOAD_USER_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_104" /* CORE_LOAD_USER_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterData/userGroup.js



var userGroup_requestState = types["_128" /* REQUEST_STATE */];

/* harmony default export */ var masterData_userGroup = ({
    userGroups: function userGroups() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userGroup_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_112" /* CORE_LOAD_USER_GROUP_REQUEST */]:
                return state;
            case types["_113" /* CORE_LOAD_USER_GROUP_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_111" /* CORE_LOAD_USER_GROUP_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    userGroup: function userGroup() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userGroup_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_109" /* CORE_LOAD_USER_GROUP_BY_ID_REQUEST */]:
                return state;
            case types["_110" /* CORE_LOAD_USER_GROUP_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_108" /* CORE_LOAD_USER_GROUP_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/masterData/stations.js



var stations_requestState = types["_128" /* REQUEST_STATE */];

/* harmony default export */ var masterData_stations = ({
    stations: function stations() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stations_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_102" /* CORE_LOAD_STATION_REQUEST */]:
                return state;
            case types["_103" /* CORE_LOAD_STATION_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_101" /* CORE_LOAD_STATION_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    station: function station() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stations_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_99" /* CORE_LOAD_STATION_BY_ID_REQUEST */]:
                return state;
            case types["_100" /* CORE_LOAD_STATION_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_98" /* CORE_LOAD_STATION_BY_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/reducerReportAPI.js



var reducerReportAPI_requestState = types["_128" /* REQUEST_STATE */];

/* harmony default export */ var reducerReportAPI = ({
    report: function report() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerReportAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_66" /* CORE_GET_REPORT_REQUEST */]:
                return state;
            case types["_67" /* CORE_GET_REPORT_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    } else return [];
                } else {
                    return [];
                }
            case types["_65" /* CORE_GET_REPORT_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    reportExportExcel: function reportExportExcel() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerReportAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_51" /* CORE_GET_EXCEL_REPORT_REQUEST */]:
                return state;
            case types["_52" /* CORE_GET_EXCEL_REPORT_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        console.log('data=>', data);
                        return data;
                    } else return [];
                } else {
                    return [];
                }
            case types["_50" /* CORE_GET_EXCEL_REPORT_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/reducerServiceAPI.js



var reducerServiceAPI_requestState = types["_128" /* REQUEST_STATE */];

/* harmony default export */ var reducerServiceAPI = ({

    serviceStationList: function serviceStationList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_82" /* CORE_GET_STATION_LIST_REQUEST */]:
                return state;
            case types["_83" /* CORE_GET_STATION_LIST_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_81" /* CORE_GET_STATION_LIST_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    serviceDeviceList: function serviceDeviceList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_48" /* CORE_GET_DEVICE_LIST_REQUEST */]:
                return state;
            case types["_49" /* CORE_GET_DEVICE_LIST_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }case types["_47" /* CORE_GET_DEVICE_LIST_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    serviceStationRealKpi: function serviceStationRealKpi() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_88" /* CORE_GET_STATION_REAL_KPI_REQUEST */]:
                return state;
            case types["_89" /* CORE_GET_STATION_REAL_KPI_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        datas = _action$payload3.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }case types["_84" /* CORE_GET_STATION_REAL_KPI_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    serviceStationRealKpiForHomeSite: function serviceStationRealKpiForHomeSite() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_86" /* CORE_GET_STATION_REAL_KPI_HOMESITE_REQUEST */]:
                return state;
            case types["_87" /* CORE_GET_STATION_REAL_KPI_HOMESITE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        datas = _action$payload4.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }case types["_85" /* CORE_GET_STATION_REAL_KPI_HOMESITE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    serviceDeviceKpi: function serviceDeviceKpi() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_42" /* CORE_GET_DEVICE_KPI_REQUEST */]:
                return state;
            case types["_43" /* CORE_GET_DEVICE_KPI_SUCCESS */]:
                if (action.payload) {
                    var _action$payload5 = action.payload,
                        result = _action$payload5.result,
                        datas = _action$payload5.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_38" /* CORE_GET_DEVICE_KPI_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    serviceDeviceKpiDay: function serviceDeviceKpiDay() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_36" /* CORE_GET_DEVICE_KPI_DAY_REQUEST */]:
                return state;
            case types["_37" /* CORE_GET_DEVICE_KPI_DAY_SUCCESS */]:
                if (action.payload) {
                    var _action$payload6 = action.payload,
                        result = _action$payload6.result,
                        datas = _action$payload6.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_35" /* CORE_GET_DEVICE_KPI_DAY_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    serviceDeviceKpiMonth: function serviceDeviceKpiMonth() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_40" /* CORE_GET_DEVICE_KPI_MONTH_REQUEST */]:
                return state;
            case types["_41" /* CORE_GET_DEVICE_KPI_MONTH_SUCCESS */]:
                if (action.payload) {
                    var _action$payload7 = action.payload,
                        result = _action$payload7.result,
                        datas = _action$payload7.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_39" /* CORE_GET_DEVICE_KPI_MONTH_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    serviceDeviceKpiYear: function serviceDeviceKpiYear() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_45" /* CORE_GET_DEVICE_KPI_YEAR_REQUEST */]:
                return state;
            case types["_46" /* CORE_GET_DEVICE_KPI_YEAR_SUCCESS */]:
                if (action.payload) {
                    var _action$payload8 = action.payload,
                        result = _action$payload8.result,
                        datas = _action$payload8.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_44" /* CORE_GET_DEVICE_KPI_YEAR_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    deviceFiveMinutesData: function deviceFiveMinutesData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_21" /* CORE_GET_DEVICE_FIVE_MINUTES_REQUEST */]:
                return state;
            case types["_22" /* CORE_GET_DEVICE_FIVE_MINUTES_SUCCESS */]:
                if (action.payload) {
                    var _action$payload9 = action.payload,
                        result = _action$payload9.result,
                        datas = _action$payload9.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_20" /* CORE_GET_DEVICE_FIVE_MINUTES_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    kpiStationHourData: function kpiStationHourData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_57" /* CORE_GET_KPI_STATION_HOUR_REQUEST */]:
                return state;
            case types["_58" /* CORE_GET_KPI_STATION_HOUR_SUCCESS */]:
                if (action.payload) {
                    var _action$payload10 = action.payload,
                        result = _action$payload10.result,
                        datas = _action$payload10.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_56" /* CORE_GET_KPI_STATION_HOUR_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    kpiStationDayData: function kpiStationDayData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_54" /* CORE_GET_KPI_STATION_DAY_REQUEST */]:
                return state;
            case types["_55" /* CORE_GET_KPI_STATION_DAY_SUCCESS */]:
                if (action.payload) {
                    var _action$payload11 = action.payload,
                        result = _action$payload11.result,
                        datas = _action$payload11.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_53" /* CORE_GET_KPI_STATION_DAY_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    kpiStationMonthData: function kpiStationMonthData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_60" /* CORE_GET_KPI_STATION_MONTH_REQUEST */]:
                return state;
            case types["_61" /* CORE_GET_KPI_STATION_MONTH_SUCCESS */]:
                if (action.payload) {
                    var _action$payload12 = action.payload,
                        result = _action$payload12.result,
                        datas = _action$payload12.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_59" /* CORE_GET_KPI_STATION_MONTH_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    kpiStationYearData: function kpiStationYearData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerServiceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_63" /* CORE_GET_KPI_STATION_YEAR_REQUEST */]:
                return state;
            case types["_64" /* CORE_GET_KPI_STATION_YEAR_SUCCESS */]:
                if (action.payload) {
                    var _action$payload13 = action.payload,
                        result = _action$payload13.result,
                        datas = _action$payload13.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_62" /* CORE_GET_KPI_STATION_YEAR_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/reducerDeviceAPI.js



var reducerDeviceAPI_requestState = types["_128" /* REQUEST_STATE */];

/* harmony default export */ var reducerDeviceAPI = ({
    allDevice: function allDevice() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDeviceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_12" /* CORE_GET_ALL_DEVICE_REQUEST */]:
                return state;
            case types["_13" /* CORE_GET_ALL_DEVICE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_11" /* CORE_GET_ALL_DEVICE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    loadDeviceByPlantCode: function loadDeviceByPlantCode() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDeviceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_18" /* CORE_GET_DEVICE_BY_PLANTCODE_REQUEST */]:
                return state;
            case types["_19" /* CORE_GET_DEVICE_BY_PLANTCODE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }case types["_17" /* CORE_GET_DEVICE_BY_PLANTCODE_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    deviceChangeImg: function deviceChangeImg() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDeviceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["F" /* CORE_CHANGE_IMG_DEVICE_REQUEST */]:
                return state;
            case types["G" /* CORE_CHANGE_IMG_DEVICE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["E" /* CORE_CHANGE_IMG_DEVICE_FAILURE */]:
                return {};
            default:
                return state;
        }
    },

    loadDeviceGetKPI: function loadDeviceGetKPI() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDeviceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_30" /* CORE_GET_DEVICE_GET_KPI_REQUEST */]:
                return state;
            case types["_31" /* CORE_GET_DEVICE_GET_KPI_SUCCESS */]:
                if (action.payload) {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        datas = _action$payload4.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }case types["_26" /* CORE_GET_DEVICE_GET_KPI_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    loadDeviceGetKPIDay: function loadDeviceGetKPIDay() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDeviceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_24" /* CORE_GET_DEVICE_GET_KPI_DAY_REQUEST */]:
                return state;
            case types["_25" /* CORE_GET_DEVICE_GET_KPI_DAY_SUCCESS */]:
                if (action.payload) {
                    var _action$payload5 = action.payload,
                        result = _action$payload5.result,
                        datas = _action$payload5.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }case types["_23" /* CORE_GET_DEVICE_GET_KPI_DAY_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    loadDeviceGetKPIMonth: function loadDeviceGetKPIMonth() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDeviceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_28" /* CORE_GET_DEVICE_GET_KPI_MONTH_REQUEST */]:
                return state;
            case types["_29" /* CORE_GET_DEVICE_GET_KPI_MONTH_SUCCESS */]:
                if (action.payload) {
                    var _action$payload6 = action.payload,
                        result = _action$payload6.result,
                        datas = _action$payload6.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }case types["_27" /* CORE_GET_DEVICE_GET_KPI_MONTH_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    loadDeviceGetKPIYear: function loadDeviceGetKPIYear() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerDeviceAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_33" /* CORE_GET_DEVICE_GET_KPI_YEAR_REQUEST */]:
                return state;
            case types["_34" /* CORE_GET_DEVICE_GET_KPI_YEAR_SUCCESS */]:
                if (action.payload) {
                    var _action$payload7 = action.payload,
                        result = _action$payload7.result,
                        datas = _action$payload7.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }case types["_32" /* CORE_GET_DEVICE_GET_KPI_YEAR_FAILURE */]:
                return [];
            default:
                return state;
        }
    }

});
// CONCATENATED MODULE: ./src/app/redux/reducers/reducerCompanyAPI.js



var reducerCompanyAPI_requestState = types["_128" /* REQUEST_STATE */];

/* harmony default export */ var reducerCompanyAPI = ({
    allCompany: function allCompany() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerCompanyAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_9" /* CORE_GET_ALL_COMPANY_REQUEST */]:
                return state;
            case types["_10" /* CORE_GET_ALL_COMPANY_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_8" /* CORE_GET_ALL_COMPANY_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    companyById: function companyById() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerCompanyAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_15" /* CORE_GET_COMPANY_BY_ID_REQUEST */]:
                return state;
            case types["_16" /* CORE_GET_COMPANY_BY_ID_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["_14" /* CORE_GET_COMPANY_BY_ID_FAILURE */]:
                return [];
            default:
                return state;
        }
    },

    updateImg: function updateImg() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerCompanyAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["L" /* CORE_CHANGE_USER_PROFILE_REQUEST */]:
                return state;
            case types["M" /* CORE_CHANGE_USER_PROFILE_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case types["K" /* CORE_CHANGE_USER_PROFILE_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/reducerStationAPI.js



var reducerStationAPI_requestState = types["_128" /* REQUEST_STATE */];

/* harmony default export */ var reducerStationAPI = ({
    station: function station() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerStationAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_90" /* CORE_GET_STATION_REQUEST */]:
                return state;
            case types["_91" /* CORE_GET_STATION_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    } else return [];
                } else {
                    return [];
                }
            case types["_68" /* CORE_GET_STATION_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    stationHour: function stationHour() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerStationAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_73" /* CORE_GET_STATION_KPI_HOUR_REQUEST */]:
                return state;
            case types["_74" /* CORE_GET_STATION_KPI_HOUR_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_72" /* CORE_GET_STATION_KPI_HOUR_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    stationDay: function stationDay() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerStationAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_70" /* CORE_GET_STATION_KPI_DAY_REQUEST */]:
                return state;
            case types["_71" /* CORE_GET_STATION_KPI_DAY_SUCCESS */]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        datas = _action$payload3.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_69" /* CORE_GET_STATION_KPI_DAY_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    stationMonth: function stationMonth() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerStationAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_76" /* CORE_GET_STATION_KPI_MONTH_REQUEST */]:
                return state;
            case types["_77" /* CORE_GET_STATION_KPI_MONTH_SUCCESS */]:
                if (action.payload) {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        datas = _action$payload4.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_75" /* CORE_GET_STATION_KPI_MONTH_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    stationYear: function stationYear() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerStationAPI_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["_79" /* CORE_GET_STATION_KPI_YEAR_REQUEST */]:
                return state;
            case types["_80" /* CORE_GET_STATION_KPI_YEAR_SUCCESS */]:
                if (action.payload) {
                    var _action$payload5 = action.payload,
                        result = _action$payload5.result,
                        datas = _action$payload5.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["_78" /* CORE_GET_STATION_KPI_YEAR_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers.js

// import { reducer as formReducer } from 'redux-form'
// import { reducer as notificationsReducer } from 'reapop'














/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    authen: reducerAuth.authen,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API
    isLoading: reducerCallAPI.isLoading,
    verify: reducerAuth.verifyLogin,

    sites: masterData_site.sites,
    site: masterData_site.site,
    siteChangeImg: masterData_site.siteChangeImg,
    users: masterData_user.users,
    user: masterData_user.user,
    userGroups: masterData_userGroup.userGroups,
    userGroup: masterData_userGroup.userGroup,
    stations: masterData_stations.stations,
    station: masterData_stations.station,
    report: reducerReportAPI.report,
    reportExportExcel: reducerReportAPI.reportExportExcel,
    serviceStationList: reducerServiceAPI.serviceStationList,
    serviceDeviceList: reducerServiceAPI.serviceDeviceList,
    serviceDeviceKpi: reducerServiceAPI.serviceDeviceKpi,
    deviceFiveMinutesData: reducerServiceAPI.deviceFiveMinutesData,
    kpiStationHourData: reducerServiceAPI.kpiStationHourData,
    kpiStationDayData: reducerServiceAPI.kpiStationDayData,
    kpiStationMonthData: reducerServiceAPI.kpiStationMonthData,
    kpiStationYearData: reducerServiceAPI.kpiStationYearData,
    serviceDeviceKpiDay: reducerServiceAPI.serviceDeviceKpiDay,
    serviceDeviceKpiMonth: reducerServiceAPI.serviceDeviceKpiMonth,
    serviceDeviceKpiYear: reducerServiceAPI.serviceDeviceKpiYear,
    serviceStationRealKpi: reducerServiceAPI.serviceStationRealKpi,
    serviceStationRealKpiForHomeSite: reducerServiceAPI.serviceStationRealKpiForHomeSite,
    allDevice: reducerDeviceAPI.allDevice,
    loadDeviceByPlantCode: reducerDeviceAPI.loadDeviceByPlantCode,
    deviceChangeImg: reducerDeviceAPI.deviceChangeImg,
    loadDeviceGetKPI: reducerDeviceAPI.loadDeviceGetKPI,
    loadDeviceGetKPIDay: reducerDeviceAPI.loadDeviceGetKPIDay,
    loadDeviceGetKPIMonth: reducerDeviceAPI.loadDeviceGetKPIMonth,
    loadDeviceGetKPIYear: reducerDeviceAPI.loadDeviceGetKPIYear,
    allCompany: reducerCompanyAPI.allCompany,
    updateImg: reducerCompanyAPI.updateImg,
    companyById: reducerCompanyAPI.companyById,
    stationHour: reducerStationAPI.stationHour,
    stationDay: reducerStationAPI.stationDay,
    stationMonth: reducerStationAPI.stationMonth,
    stationYear: reducerStationAPI.stationYear,
    apiDataReportAir: masterData_site.apiDataReportAir,
    apiDataReportAirWind: masterData_site.apiDataReportAirWind,
    apiDataReportAirPressure: masterData_site.apiDataReportAirPressure,
    apiDataReportAir17: masterData_site.apiDataReportAir17,
    apiDataReportAirWind17: masterData_site.apiDataReportAirWind17,
    apiDataReportAirPressure17: masterData_site.apiDataReportAirPressure17,
    apiDataReportAirCloud17: masterData_site.apiDataReportAirCloud17,
    apiDataReportAirCloud: masterData_site.apiDataReportAirCloud
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ })

},[50]);


// WEBPACK FOOTER //
// app.3bfa19406c356b8b8188.js